var Qa = Object.defineProperty, Xa = Object.defineProperties;
var Ja = Object.getOwnPropertyDescriptors;
var Bt = Object.getOwnPropertySymbols;
var Za = Object.prototype.hasOwnProperty, eo = Object.prototype.propertyIsEnumerable;
var Ft = (r, t, e) => t in r ? Qa(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, xe = (r, t) => {
  for (var e in t || (t = {}))
    Za.call(t, e) && Ft(r, e, t[e]);
  if (Bt)
    for (var e of Bt(t))
      eo.call(t, e) && Ft(r, e, t[e]);
  return r;
}, Je = (r, t) => Xa(r, Ja(t));
import * as X from "react";
import W, { createContext as ea, useState as ue, useEffect as $e, useContext as Ge, PureComponent as ro, createRef as Ht, useRef as lt } from "react";
import { Button as Ee, Tooltip as to, message as no, Modal as vr, Upload as ao } from "antd";
var Ze = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function vt(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var er = { exports: {} }, ze = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wt;
function oo() {
  if (Wt) return ze;
  Wt = 1;
  var r = W, t = Symbol.for("react.element"), e = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(u, c, l) {
    var d, f = {}, y = null, m = null;
    l !== void 0 && (y = "" + l), c.key !== void 0 && (y = "" + c.key), c.ref !== void 0 && (m = c.ref);
    for (d in c) n.call(c, d) && !a.hasOwnProperty(d) && (f[d] = c[d]);
    if (u && u.defaultProps) for (d in c = u.defaultProps, c) f[d] === void 0 && (f[d] = c[d]);
    return { $$typeof: t, type: u, key: y, ref: m, props: f, _owner: o.current };
  }
  return ze.Fragment = e, ze.jsx = s, ze.jsxs = s, ze;
}
var Ye = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ut;
function io() {
  return Ut || (Ut = 1, process.env.NODE_ENV !== "production" && function() {
    var r = W, t = Symbol.for("react.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), x = Symbol.iterator, C = "@@iterator";
    function R(i) {
      if (i === null || typeof i != "object")
        return null;
      var h = x && i[x] || i[C];
      return typeof h == "function" ? h : null;
    }
    var S = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(i) {
      {
        for (var h = arguments.length, w = new Array(h > 1 ? h - 1 : 0), I = 1; I < h; I++)
          w[I - 1] = arguments[I];
        D("error", i, w);
      }
    }
    function D(i, h, w) {
      {
        var I = S.ReactDebugCurrentFrame, q = I.getStackAddendum();
        q !== "" && (h += "%s", w = w.concat([q]));
        var K = w.map(function(H) {
          return String(H);
        });
        K.unshift("Warning: " + h), Function.prototype.apply.call(console[i], console, K);
      }
    }
    var T = !1, g = !1, J = !1, ce = !1, $ = !1, ne;
    ne = Symbol.for("react.module.reference");
    function ie(i) {
      return !!(typeof i == "string" || typeof i == "function" || i === n || i === a || $ || i === o || i === l || i === d || ce || i === m || T || g || J || typeof i == "object" && i !== null && (i.$$typeof === y || i.$$typeof === f || i.$$typeof === s || i.$$typeof === u || i.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      i.$$typeof === ne || i.getModuleId !== void 0));
    }
    function ve(i, h, w) {
      var I = i.displayName;
      if (I)
        return I;
      var q = h.displayName || h.name || "";
      return q !== "" ? w + "(" + q + ")" : w;
    }
    function ge(i) {
      return i.displayName || "Context";
    }
    function se(i) {
      if (i == null)
        return null;
      if (typeof i.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof i == "function")
        return i.displayName || i.name || null;
      if (typeof i == "string")
        return i;
      switch (i) {
        case n:
          return "Fragment";
        case e:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case l:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case u:
            var h = i;
            return ge(h) + ".Consumer";
          case s:
            var w = i;
            return ge(w._context) + ".Provider";
          case c:
            return ve(i, i.render, "ForwardRef");
          case f:
            var I = i.displayName || null;
            return I !== null ? I : se(i.type) || "Memo";
          case y: {
            var q = i, K = q._payload, H = q._init;
            try {
              return se(H(K));
            } catch (B) {
              return null;
            }
          }
        }
      return null;
    }
    var ee = Object.assign, de = 0, re, fe, V, G, p, b, M;
    function P() {
    }
    P.__reactDisabledLog = !0;
    function E() {
      {
        if (de === 0) {
          re = console.log, fe = console.info, V = console.warn, G = console.error, p = console.group, b = console.groupCollapsed, M = console.groupEnd;
          var i = {
            configurable: !0,
            enumerable: !0,
            value: P,
            writable: !0
          };
          Object.defineProperties(console, {
            info: i,
            log: i,
            warn: i,
            error: i,
            group: i,
            groupCollapsed: i,
            groupEnd: i
          });
        }
        de++;
      }
    }
    function L() {
      {
        if (de--, de === 0) {
          var i = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ee({}, i, {
              value: re
            }),
            info: ee({}, i, {
              value: fe
            }),
            warn: ee({}, i, {
              value: V
            }),
            error: ee({}, i, {
              value: G
            }),
            group: ee({}, i, {
              value: p
            }),
            groupCollapsed: ee({}, i, {
              value: b
            }),
            groupEnd: ee({}, i, {
              value: M
            })
          });
        }
        de < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var j = S.ReactCurrentDispatcher, A;
    function N(i, h, w) {
      {
        if (A === void 0)
          try {
            throw Error();
          } catch (q) {
            var I = q.stack.trim().match(/\n( *(at )?)/);
            A = I && I[1] || "";
          }
        return `
` + A + i;
      }
    }
    var F = !1, O;
    {
      var pe = typeof WeakMap == "function" ? WeakMap : Map;
      O = new pe();
    }
    function _(i, h) {
      if (!i || F)
        return "";
      {
        var w = O.get(i);
        if (w !== void 0)
          return w;
      }
      var I;
      F = !0;
      var q = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var K;
      K = j.current, j.current = null, E();
      try {
        if (h) {
          var H = function() {
            throw Error();
          };
          if (Object.defineProperty(H.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(H, []);
            } catch (me) {
              I = me;
            }
            Reflect.construct(i, [], H);
          } else {
            try {
              H.call();
            } catch (me) {
              I = me;
            }
            i.call(H.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (me) {
            I = me;
          }
          i();
        }
      } catch (me) {
        if (me && I && typeof me.stack == "string") {
          for (var B = me.stack.split(`
`), he = I.stack.split(`
`), te = B.length - 1, ae = he.length - 1; te >= 1 && ae >= 0 && B[te] !== he[ae]; )
            ae--;
          for (; te >= 1 && ae >= 0; te--, ae--)
            if (B[te] !== he[ae]) {
              if (te !== 1 || ae !== 1)
                do
                  if (te--, ae--, ae < 0 || B[te] !== he[ae]) {
                    var we = `
` + B[te].replace(" at new ", " at ");
                    return i.displayName && we.includes("<anonymous>") && (we = we.replace("<anonymous>", i.displayName)), typeof i == "function" && O.set(i, we), we;
                  }
                while (te >= 1 && ae >= 0);
              break;
            }
        }
      } finally {
        F = !1, j.current = K, L(), Error.prepareStackTrace = q;
      }
      var Be = i ? i.displayName || i.name : "", Me = Be ? N(Be) : "";
      return typeof i == "function" && O.set(i, Me), Me;
    }
    function _e(i, h, w) {
      return _(i, !1);
    }
    function Ne(i) {
      var h = i.prototype;
      return !!(h && h.isReactComponent);
    }
    function De(i, h, w) {
      if (i == null)
        return "";
      if (typeof i == "function")
        return _(i, Ne(i));
      if (typeof i == "string")
        return N(i);
      switch (i) {
        case l:
          return N("Suspense");
        case d:
          return N("SuspenseList");
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case c:
            return _e(i.render);
          case f:
            return De(i.type, h, w);
          case y: {
            var I = i, q = I._payload, K = I._init;
            try {
              return De(K(q), h, w);
            } catch (H) {
            }
          }
        }
      return "";
    }
    var qe = Object.prototype.hasOwnProperty, Rt = {}, Ot = S.ReactDebugCurrentFrame;
    function Xe(i) {
      if (i) {
        var h = i._owner, w = De(i.type, i._source, h ? h.type : null);
        Ot.setExtraStackFrame(w);
      } else
        Ot.setExtraStackFrame(null);
    }
    function Ta(i, h, w, I, q) {
      {
        var K = Function.call.bind(qe);
        for (var H in i)
          if (K(i, H)) {
            var B = void 0;
            try {
              if (typeof i[H] != "function") {
                var he = Error((I || "React class") + ": " + w + " type `" + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[H] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw he.name = "Invariant Violation", he;
              }
              B = i[H](h, H, I, w, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (te) {
              B = te;
            }
            B && !(B instanceof Error) && (Xe(q), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", I || "React class", w, H, typeof B), Xe(null)), B instanceof Error && !(B.message in Rt) && (Rt[B.message] = !0, Xe(q), k("Failed %s type: %s", w, B.message), Xe(null));
          }
      }
    }
    var Ia = Array.isArray;
    function dr(i) {
      return Ia(i);
    }
    function Pa(i) {
      {
        var h = typeof Symbol == "function" && Symbol.toStringTag, w = h && i[Symbol.toStringTag] || i.constructor.name || "Object";
        return w;
      }
    }
    function ja(i) {
      try {
        return St(i), !1;
      } catch (h) {
        return !0;
      }
    }
    function St(i) {
      return "" + i;
    }
    function Et(i) {
      if (ja(i))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Pa(i)), St(i);
    }
    var Tt = S.ReactCurrentOwner, Aa = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, It, Pt;
    function Da(i) {
      if (qe.call(i, "ref")) {
        var h = Object.getOwnPropertyDescriptor(i, "ref").get;
        if (h && h.isReactWarning)
          return !1;
      }
      return i.ref !== void 0;
    }
    function Ma(i) {
      if (qe.call(i, "key")) {
        var h = Object.getOwnPropertyDescriptor(i, "key").get;
        if (h && h.isReactWarning)
          return !1;
      }
      return i.key !== void 0;
    }
    function ka(i, h) {
      typeof i.ref == "string" && Tt.current;
    }
    function Na(i, h) {
      {
        var w = function() {
          It || (It = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", h));
        };
        w.isReactWarning = !0, Object.defineProperty(i, "key", {
          get: w,
          configurable: !0
        });
      }
    }
    function La(i, h) {
      {
        var w = function() {
          Pt || (Pt = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", h));
        };
        w.isReactWarning = !0, Object.defineProperty(i, "ref", {
          get: w,
          configurable: !0
        });
      }
    }
    var Ba = function(i, h, w, I, q, K, H) {
      var B = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: i,
        key: h,
        ref: w,
        props: H,
        // Record the component responsible for creating this element.
        _owner: K
      };
      return B._store = {}, Object.defineProperty(B._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(B, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: I
      }), Object.defineProperty(B, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: q
      }), Object.freeze && (Object.freeze(B.props), Object.freeze(B)), B;
    };
    function Fa(i, h, w, I, q) {
      {
        var K, H = {}, B = null, he = null;
        w !== void 0 && (Et(w), B = "" + w), Ma(h) && (Et(h.key), B = "" + h.key), Da(h) && (he = h.ref, ka(h, q));
        for (K in h)
          qe.call(h, K) && !Aa.hasOwnProperty(K) && (H[K] = h[K]);
        if (i && i.defaultProps) {
          var te = i.defaultProps;
          for (K in te)
            H[K] === void 0 && (H[K] = te[K]);
        }
        if (B || he) {
          var ae = typeof i == "function" ? i.displayName || i.name || "Unknown" : i;
          B && Na(H, ae), he && La(H, ae);
        }
        return Ba(i, B, he, q, I, Tt.current, H);
      }
    }
    var fr = S.ReactCurrentOwner, jt = S.ReactDebugCurrentFrame;
    function Le(i) {
      if (i) {
        var h = i._owner, w = De(i.type, i._source, h ? h.type : null);
        jt.setExtraStackFrame(w);
      } else
        jt.setExtraStackFrame(null);
    }
    var pr;
    pr = !1;
    function hr(i) {
      return typeof i == "object" && i !== null && i.$$typeof === t;
    }
    function At() {
      {
        if (fr.current) {
          var i = se(fr.current.type);
          if (i)
            return `

Check the render method of \`` + i + "`.";
        }
        return "";
      }
    }
    function Ha(i) {
      return "";
    }
    var Dt = {};
    function Wa(i) {
      {
        var h = At();
        if (!h) {
          var w = typeof i == "string" ? i : i.displayName || i.name;
          w && (h = `

Check the top-level render call using <` + w + ">.");
        }
        return h;
      }
    }
    function Mt(i, h) {
      {
        if (!i._store || i._store.validated || i.key != null)
          return;
        i._store.validated = !0;
        var w = Wa(h);
        if (Dt[w])
          return;
        Dt[w] = !0;
        var I = "";
        i && i._owner && i._owner !== fr.current && (I = " It was passed a child from " + se(i._owner.type) + "."), Le(i), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', w, I), Le(null);
      }
    }
    function kt(i, h) {
      {
        if (typeof i != "object")
          return;
        if (dr(i))
          for (var w = 0; w < i.length; w++) {
            var I = i[w];
            hr(I) && Mt(I, h);
          }
        else if (hr(i))
          i._store && (i._store.validated = !0);
        else if (i) {
          var q = R(i);
          if (typeof q == "function" && q !== i.entries)
            for (var K = q.call(i), H; !(H = K.next()).done; )
              hr(H.value) && Mt(H.value, h);
        }
      }
    }
    function Ua(i) {
      {
        var h = i.type;
        if (h == null || typeof h == "string")
          return;
        var w;
        if (typeof h == "function")
          w = h.propTypes;
        else if (typeof h == "object" && (h.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        h.$$typeof === f))
          w = h.propTypes;
        else
          return;
        if (w) {
          var I = se(h);
          Ta(w, i.props, "prop", I, i);
        } else if (h.PropTypes !== void 0 && !pr) {
          pr = !0;
          var q = se(h);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", q || "Unknown");
        }
        typeof h.getDefaultProps == "function" && !h.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function qa(i) {
      {
        for (var h = Object.keys(i.props), w = 0; w < h.length; w++) {
          var I = h[w];
          if (I !== "children" && I !== "key") {
            Le(i), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", I), Le(null);
            break;
          }
        }
        i.ref !== null && (Le(i), k("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Nt = {};
    function Lt(i, h, w, I, q, K) {
      {
        var H = ie(i);
        if (!H) {
          var B = "";
          (i === void 0 || typeof i == "object" && i !== null && Object.keys(i).length === 0) && (B += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var he = Ha();
          he ? B += he : B += At();
          var te;
          i === null ? te = "null" : dr(i) ? te = "array" : i !== void 0 && i.$$typeof === t ? (te = "<" + (se(i.type) || "Unknown") + " />", B = " Did you accidentally export a JSX literal instead of a component?") : te = typeof i, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", te, B);
        }
        var ae = Fa(i, h, w, q, K);
        if (ae == null)
          return ae;
        if (H) {
          var we = h.children;
          if (we !== void 0)
            if (I)
              if (dr(we)) {
                for (var Be = 0; Be < we.length; Be++)
                  kt(we[Be], i);
                Object.freeze && Object.freeze(we);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kt(we, i);
        }
        if (qe.call(h, "key")) {
          var Me = se(i), me = Object.keys(h).filter(function(Ga) {
            return Ga !== "key";
          }), mr = me.length > 0 ? "{key: someKey, " + me.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Nt[Me + mr]) {
            var $a = me.length > 0 ? "{" + me.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mr, Me, $a, Me), Nt[Me + mr] = !0;
          }
        }
        return i === n ? qa(ae) : Ua(ae), ae;
      }
    }
    function za(i, h, w) {
      return Lt(i, h, w, !0);
    }
    function Ya(i, h, w) {
      return Lt(i, h, w, !1);
    }
    var Va = Ya, Ka = za;
    Ye.Fragment = n, Ye.jsx = Va, Ye.jsxs = Ka;
  }()), Ye;
}
var qt;
function so() {
  return qt || (qt = 1, process.env.NODE_ENV === "production" ? er.exports = oo() : er.exports = io()), er.exports;
}
var v = so();
const ra = (r, t, e) => {
  const n = r[t];
  return n ? typeof n == "function" ? n() : Promise.resolve(n) : new Promise((o, a) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      a.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + t + (t.split("/").length !== e ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
var co = (r, t, e) => new Promise((n, o) => {
  var a = (c) => {
    try {
      u(e.next(c));
    } catch (l) {
      o(l);
    }
  }, s = (c) => {
    try {
      u(e.throw(c));
    } catch (l) {
      o(l);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(a, s);
  u((e = e.apply(r, t)).next());
});
const Qe = ea(), uo = ({ children: r, defaultLanguage: t = "es" }) => {
  const [e, n] = ue(t), [o, a] = ue({}), [s, u] = ue(!0);
  return console.log({ language: e }), $e(() => {
    co(null, null, function* () {
      try {
        const l = yield ra(/* @__PURE__ */ Object.assign({ "../localization/ca.json": () => import("./ca-Dx2fKoj2.js"), "../localization/de.json": () => import("./de-CFMnHDnf.js"), "../localization/en.json": () => import("./en-BhudIc7g.js"), "../localization/es.json": () => import("./es-PKOgVxNj.js"), "../localization/fr.json": () => import("./fr-JMiDWUjO.js"), "../localization/it.json": () => import("./it-CWUxFkve.js"), "../localization/ja.json": () => import("./ja-Dn3M5nnt.js"), "../localization/pt.json": () => import("./pt-Dsikv76b.js"), "../localization/pt_Br.json": () => import("./pt_Br-DAr-vXi5.js"), "../localization/ru.json": () => import("./ru-Dho3AZn6.js"), "../localization/zh.json": () => import("./zh-Ck5ls1ON.js") }), `../localization/${e}.json`, 3);
        a(l.default);
      } catch (l) {
        const d = yield import("./en-BhudIc7g.js");
        a(d.default), console.warn(`Translation file for language ${e} not found, using default (en)`);
      } finally {
        u(!1);
      }
    });
  }, [e]), /* @__PURE__ */ v.jsx(Qe.Provider, { value: { translations: o, language: e, setLanguage: n, isLoading: s }, children: r });
};
var rr = { exports: {} }, tr = { exports: {} }, z = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zt;
function lo() {
  if (zt) return z;
  zt = 1;
  var r = typeof Symbol == "function" && Symbol.for, t = r ? Symbol.for("react.element") : 60103, e = r ? Symbol.for("react.portal") : 60106, n = r ? Symbol.for("react.fragment") : 60107, o = r ? Symbol.for("react.strict_mode") : 60108, a = r ? Symbol.for("react.profiler") : 60114, s = r ? Symbol.for("react.provider") : 60109, u = r ? Symbol.for("react.context") : 60110, c = r ? Symbol.for("react.async_mode") : 60111, l = r ? Symbol.for("react.concurrent_mode") : 60111, d = r ? Symbol.for("react.forward_ref") : 60112, f = r ? Symbol.for("react.suspense") : 60113, y = r ? Symbol.for("react.suspense_list") : 60120, m = r ? Symbol.for("react.memo") : 60115, x = r ? Symbol.for("react.lazy") : 60116, C = r ? Symbol.for("react.block") : 60121, R = r ? Symbol.for("react.fundamental") : 60117, S = r ? Symbol.for("react.responder") : 60118, k = r ? Symbol.for("react.scope") : 60119;
  function D(g) {
    if (typeof g == "object" && g !== null) {
      var J = g.$$typeof;
      switch (J) {
        case t:
          switch (g = g.type, g) {
            case c:
            case l:
            case n:
            case a:
            case o:
            case f:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case u:
                case d:
                case x:
                case m:
                case s:
                  return g;
                default:
                  return J;
              }
          }
        case e:
          return J;
      }
    }
  }
  function T(g) {
    return D(g) === l;
  }
  return z.AsyncMode = c, z.ConcurrentMode = l, z.ContextConsumer = u, z.ContextProvider = s, z.Element = t, z.ForwardRef = d, z.Fragment = n, z.Lazy = x, z.Memo = m, z.Portal = e, z.Profiler = a, z.StrictMode = o, z.Suspense = f, z.isAsyncMode = function(g) {
    return T(g) || D(g) === c;
  }, z.isConcurrentMode = T, z.isContextConsumer = function(g) {
    return D(g) === u;
  }, z.isContextProvider = function(g) {
    return D(g) === s;
  }, z.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === t;
  }, z.isForwardRef = function(g) {
    return D(g) === d;
  }, z.isFragment = function(g) {
    return D(g) === n;
  }, z.isLazy = function(g) {
    return D(g) === x;
  }, z.isMemo = function(g) {
    return D(g) === m;
  }, z.isPortal = function(g) {
    return D(g) === e;
  }, z.isProfiler = function(g) {
    return D(g) === a;
  }, z.isStrictMode = function(g) {
    return D(g) === o;
  }, z.isSuspense = function(g) {
    return D(g) === f;
  }, z.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === l || g === a || g === o || g === f || g === y || typeof g == "object" && g !== null && (g.$$typeof === x || g.$$typeof === m || g.$$typeof === s || g.$$typeof === u || g.$$typeof === d || g.$$typeof === R || g.$$typeof === S || g.$$typeof === k || g.$$typeof === C);
  }, z.typeOf = D, z;
}
var Y = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yt;
function fo() {
  return Yt || (Yt = 1, process.env.NODE_ENV !== "production" && function() {
    var r = typeof Symbol == "function" && Symbol.for, t = r ? Symbol.for("react.element") : 60103, e = r ? Symbol.for("react.portal") : 60106, n = r ? Symbol.for("react.fragment") : 60107, o = r ? Symbol.for("react.strict_mode") : 60108, a = r ? Symbol.for("react.profiler") : 60114, s = r ? Symbol.for("react.provider") : 60109, u = r ? Symbol.for("react.context") : 60110, c = r ? Symbol.for("react.async_mode") : 60111, l = r ? Symbol.for("react.concurrent_mode") : 60111, d = r ? Symbol.for("react.forward_ref") : 60112, f = r ? Symbol.for("react.suspense") : 60113, y = r ? Symbol.for("react.suspense_list") : 60120, m = r ? Symbol.for("react.memo") : 60115, x = r ? Symbol.for("react.lazy") : 60116, C = r ? Symbol.for("react.block") : 60121, R = r ? Symbol.for("react.fundamental") : 60117, S = r ? Symbol.for("react.responder") : 60118, k = r ? Symbol.for("react.scope") : 60119;
    function D(_) {
      return typeof _ == "string" || typeof _ == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      _ === n || _ === l || _ === a || _ === o || _ === f || _ === y || typeof _ == "object" && _ !== null && (_.$$typeof === x || _.$$typeof === m || _.$$typeof === s || _.$$typeof === u || _.$$typeof === d || _.$$typeof === R || _.$$typeof === S || _.$$typeof === k || _.$$typeof === C);
    }
    function T(_) {
      if (typeof _ == "object" && _ !== null) {
        var _e = _.$$typeof;
        switch (_e) {
          case t:
            var Ne = _.type;
            switch (Ne) {
              case c:
              case l:
              case n:
              case a:
              case o:
              case f:
                return Ne;
              default:
                var De = Ne && Ne.$$typeof;
                switch (De) {
                  case u:
                  case d:
                  case x:
                  case m:
                  case s:
                    return De;
                  default:
                    return _e;
                }
            }
          case e:
            return _e;
        }
      }
    }
    var g = c, J = l, ce = u, $ = s, ne = t, ie = d, ve = n, ge = x, se = m, ee = e, de = a, re = o, fe = f, V = !1;
    function G(_) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), p(_) || T(_) === c;
    }
    function p(_) {
      return T(_) === l;
    }
    function b(_) {
      return T(_) === u;
    }
    function M(_) {
      return T(_) === s;
    }
    function P(_) {
      return typeof _ == "object" && _ !== null && _.$$typeof === t;
    }
    function E(_) {
      return T(_) === d;
    }
    function L(_) {
      return T(_) === n;
    }
    function j(_) {
      return T(_) === x;
    }
    function A(_) {
      return T(_) === m;
    }
    function N(_) {
      return T(_) === e;
    }
    function F(_) {
      return T(_) === a;
    }
    function O(_) {
      return T(_) === o;
    }
    function pe(_) {
      return T(_) === f;
    }
    Y.AsyncMode = g, Y.ConcurrentMode = J, Y.ContextConsumer = ce, Y.ContextProvider = $, Y.Element = ne, Y.ForwardRef = ie, Y.Fragment = ve, Y.Lazy = ge, Y.Memo = se, Y.Portal = ee, Y.Profiler = de, Y.StrictMode = re, Y.Suspense = fe, Y.isAsyncMode = G, Y.isConcurrentMode = p, Y.isContextConsumer = b, Y.isContextProvider = M, Y.isElement = P, Y.isForwardRef = E, Y.isFragment = L, Y.isLazy = j, Y.isMemo = A, Y.isPortal = N, Y.isProfiler = F, Y.isStrictMode = O, Y.isSuspense = pe, Y.isValidElementType = D, Y.typeOf = T;
  }()), Y;
}
var Vt;
function ta() {
  return Vt || (Vt = 1, process.env.NODE_ENV === "production" ? tr.exports = lo() : tr.exports = fo()), tr.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var gr, Kt;
function po() {
  if (Kt) return gr;
  Kt = 1;
  var r = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, e = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var s = {}, u = 0; u < 10; u++)
        s["_" + String.fromCharCode(u)] = u;
      var c = Object.getOwnPropertyNames(s).map(function(d) {
        return s[d];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        l[d] = d;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch (d) {
      return !1;
    }
  }
  return gr = o() ? Object.assign : function(a, s) {
    for (var u, c = n(a), l, d = 1; d < arguments.length; d++) {
      u = Object(arguments[d]);
      for (var f in u)
        t.call(u, f) && (c[f] = u[f]);
      if (r) {
        l = r(u);
        for (var y = 0; y < l.length; y++)
          e.call(u, l[y]) && (c[l[y]] = u[l[y]]);
      }
    }
    return c;
  }, gr;
}
var yr, $t;
function gt() {
  if ($t) return yr;
  $t = 1;
  var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return yr = r, yr;
}
var br, Gt;
function na() {
  return Gt || (Gt = 1, br = Function.call.bind(Object.prototype.hasOwnProperty)), br;
}
var _r, Qt;
function ho() {
  if (Qt) return _r;
  Qt = 1;
  var r = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ gt(), e = {}, n = /* @__PURE__ */ na();
    r = function(a) {
      var s = "Warning: " + a;
      typeof console != "undefined" && console.error(s);
      try {
        throw new Error(s);
      } catch (u) {
      }
    };
  }
  function o(a, s, u, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in a)
        if (n(a, d)) {
          var f;
          try {
            if (typeof a[d] != "function") {
              var y = Error(
                (c || "React class") + ": " + u + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw y.name = "Invariant Violation", y;
            }
            f = a[d](s, d, c, u, null, t);
          } catch (x) {
            f = x;
          }
          if (f && !(f instanceof Error) && r(
            (c || "React class") + ": type specification of " + u + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in e)) {
            e[f.message] = !0;
            var m = l ? l() : "";
            r(
              "Failed " + u + " type: " + f.message + (m != null ? m : "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (e = {});
  }, _r = o, _r;
}
var wr, Xt;
function mo() {
  if (Xt) return wr;
  Xt = 1;
  var r = ta(), t = po(), e = /* @__PURE__ */ gt(), n = /* @__PURE__ */ na(), o = /* @__PURE__ */ ho(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(u) {
    var c = "Warning: " + u;
    typeof console != "undefined" && console.error(c);
    try {
      throw new Error(c);
    } catch (l) {
    }
  });
  function s() {
    return null;
  }
  return wr = function(u, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(p) {
      var b = p && (l && p[l] || p[d]);
      if (typeof b == "function")
        return b;
    }
    var y = "<<anonymous>>", m = {
      array: S("array"),
      bigint: S("bigint"),
      bool: S("boolean"),
      func: S("function"),
      number: S("number"),
      object: S("object"),
      string: S("string"),
      symbol: S("symbol"),
      any: k(),
      arrayOf: D,
      element: T(),
      elementType: g(),
      instanceOf: J,
      node: ie(),
      objectOf: $,
      oneOf: ce,
      oneOfType: ne,
      shape: ge,
      exact: se
    };
    function x(p, b) {
      return p === b ? p !== 0 || 1 / p === 1 / b : p !== p && b !== b;
    }
    function C(p, b) {
      this.message = p, this.data = b && typeof b == "object" ? b : {}, this.stack = "";
    }
    C.prototype = Error.prototype;
    function R(p) {
      if (process.env.NODE_ENV !== "production")
        var b = {}, M = 0;
      function P(L, j, A, N, F, O, pe) {
        if (N = N || y, O = O || A, pe !== e) {
          if (c) {
            var _ = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw _.name = "Invariant Violation", _;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var _e = N + ":" + A;
            !b[_e] && // Avoid spamming the console because they are often not actionable except for lib authors
            M < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + O + "` prop on `" + N + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), b[_e] = !0, M++);
          }
        }
        return j[A] == null ? L ? j[A] === null ? new C("The " + F + " `" + O + "` is marked as required " + ("in `" + N + "`, but its value is `null`.")) : new C("The " + F + " `" + O + "` is marked as required in " + ("`" + N + "`, but its value is `undefined`.")) : null : p(j, A, N, F, O);
      }
      var E = P.bind(null, !1);
      return E.isRequired = P.bind(null, !0), E;
    }
    function S(p) {
      function b(M, P, E, L, j, A) {
        var N = M[P], F = re(N);
        if (F !== p) {
          var O = fe(N);
          return new C(
            "Invalid " + L + " `" + j + "` of type " + ("`" + O + "` supplied to `" + E + "`, expected ") + ("`" + p + "`."),
            { expectedType: p }
          );
        }
        return null;
      }
      return R(b);
    }
    function k() {
      return R(s);
    }
    function D(p) {
      function b(M, P, E, L, j) {
        if (typeof p != "function")
          return new C("Property `" + j + "` of component `" + E + "` has invalid PropType notation inside arrayOf.");
        var A = M[P];
        if (!Array.isArray(A)) {
          var N = re(A);
          return new C("Invalid " + L + " `" + j + "` of type " + ("`" + N + "` supplied to `" + E + "`, expected an array."));
        }
        for (var F = 0; F < A.length; F++) {
          var O = p(A, F, E, L, j + "[" + F + "]", e);
          if (O instanceof Error)
            return O;
        }
        return null;
      }
      return R(b);
    }
    function T() {
      function p(b, M, P, E, L) {
        var j = b[M];
        if (!u(j)) {
          var A = re(j);
          return new C("Invalid " + E + " `" + L + "` of type " + ("`" + A + "` supplied to `" + P + "`, expected a single ReactElement."));
        }
        return null;
      }
      return R(p);
    }
    function g() {
      function p(b, M, P, E, L) {
        var j = b[M];
        if (!r.isValidElementType(j)) {
          var A = re(j);
          return new C("Invalid " + E + " `" + L + "` of type " + ("`" + A + "` supplied to `" + P + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return R(p);
    }
    function J(p) {
      function b(M, P, E, L, j) {
        if (!(M[P] instanceof p)) {
          var A = p.name || y, N = G(M[P]);
          return new C("Invalid " + L + " `" + j + "` of type " + ("`" + N + "` supplied to `" + E + "`, expected ") + ("instance of `" + A + "`."));
        }
        return null;
      }
      return R(b);
    }
    function ce(p) {
      if (!Array.isArray(p))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), s;
      function b(M, P, E, L, j) {
        for (var A = M[P], N = 0; N < p.length; N++)
          if (x(A, p[N]))
            return null;
        var F = JSON.stringify(p, function(pe, _) {
          var _e = fe(_);
          return _e === "symbol" ? String(_) : _;
        });
        return new C("Invalid " + L + " `" + j + "` of value `" + String(A) + "` " + ("supplied to `" + E + "`, expected one of " + F + "."));
      }
      return R(b);
    }
    function $(p) {
      function b(M, P, E, L, j) {
        if (typeof p != "function")
          return new C("Property `" + j + "` of component `" + E + "` has invalid PropType notation inside objectOf.");
        var A = M[P], N = re(A);
        if (N !== "object")
          return new C("Invalid " + L + " `" + j + "` of type " + ("`" + N + "` supplied to `" + E + "`, expected an object."));
        for (var F in A)
          if (n(A, F)) {
            var O = p(A, F, E, L, j + "." + F, e);
            if (O instanceof Error)
              return O;
          }
        return null;
      }
      return R(b);
    }
    function ne(p) {
      if (!Array.isArray(p))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var b = 0; b < p.length; b++) {
        var M = p[b];
        if (typeof M != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + V(M) + " at index " + b + "."
          ), s;
      }
      function P(E, L, j, A, N) {
        for (var F = [], O = 0; O < p.length; O++) {
          var pe = p[O], _ = pe(E, L, j, A, N, e);
          if (_ == null)
            return null;
          _.data && n(_.data, "expectedType") && F.push(_.data.expectedType);
        }
        var _e = F.length > 0 ? ", expected one of type [" + F.join(", ") + "]" : "";
        return new C("Invalid " + A + " `" + N + "` supplied to " + ("`" + j + "`" + _e + "."));
      }
      return R(P);
    }
    function ie() {
      function p(b, M, P, E, L) {
        return ee(b[M]) ? null : new C("Invalid " + E + " `" + L + "` supplied to " + ("`" + P + "`, expected a ReactNode."));
      }
      return R(p);
    }
    function ve(p, b, M, P, E) {
      return new C(
        (p || "React class") + ": " + b + " type `" + M + "." + P + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + E + "`."
      );
    }
    function ge(p) {
      function b(M, P, E, L, j) {
        var A = M[P], N = re(A);
        if (N !== "object")
          return new C("Invalid " + L + " `" + j + "` of type `" + N + "` " + ("supplied to `" + E + "`, expected `object`."));
        for (var F in p) {
          var O = p[F];
          if (typeof O != "function")
            return ve(E, L, j, F, fe(O));
          var pe = O(A, F, E, L, j + "." + F, e);
          if (pe)
            return pe;
        }
        return null;
      }
      return R(b);
    }
    function se(p) {
      function b(M, P, E, L, j) {
        var A = M[P], N = re(A);
        if (N !== "object")
          return new C("Invalid " + L + " `" + j + "` of type `" + N + "` " + ("supplied to `" + E + "`, expected `object`."));
        var F = t({}, M[P], p);
        for (var O in F) {
          var pe = p[O];
          if (n(p, O) && typeof pe != "function")
            return ve(E, L, j, O, fe(pe));
          if (!pe)
            return new C(
              "Invalid " + L + " `" + j + "` key `" + O + "` supplied to `" + E + "`.\nBad object: " + JSON.stringify(M[P], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(p), null, "  ")
            );
          var _ = pe(A, O, E, L, j + "." + O, e);
          if (_)
            return _;
        }
        return null;
      }
      return R(b);
    }
    function ee(p) {
      switch (typeof p) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !p;
        case "object":
          if (Array.isArray(p))
            return p.every(ee);
          if (p === null || u(p))
            return !0;
          var b = f(p);
          if (b) {
            var M = b.call(p), P;
            if (b !== p.entries) {
              for (; !(P = M.next()).done; )
                if (!ee(P.value))
                  return !1;
            } else
              for (; !(P = M.next()).done; ) {
                var E = P.value;
                if (E && !ee(E[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function de(p, b) {
      return p === "symbol" ? !0 : b ? b["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && b instanceof Symbol : !1;
    }
    function re(p) {
      var b = typeof p;
      return Array.isArray(p) ? "array" : p instanceof RegExp ? "object" : de(b, p) ? "symbol" : b;
    }
    function fe(p) {
      if (typeof p == "undefined" || p === null)
        return "" + p;
      var b = re(p);
      if (b === "object") {
        if (p instanceof Date)
          return "date";
        if (p instanceof RegExp)
          return "regexp";
      }
      return b;
    }
    function V(p) {
      var b = fe(p);
      switch (b) {
        case "array":
        case "object":
          return "an " + b;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + b;
        default:
          return b;
      }
    }
    function G(p) {
      return !p.constructor || !p.constructor.name ? y : p.constructor.name;
    }
    return m.checkPropTypes = o, m.resetWarningCache = o.resetWarningCache, m.PropTypes = m, m;
  }, wr;
}
var Cr, Jt;
function vo() {
  if (Jt) return Cr;
  Jt = 1;
  var r = /* @__PURE__ */ gt();
  function t() {
  }
  function e() {
  }
  return e.resetWarningCache = t, Cr = function() {
    function n(s, u, c, l, d, f) {
      if (f !== r) {
        var y = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw y.name = "Invariant Violation", y;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: e,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Cr;
}
var Zt;
function go() {
  if (Zt) return rr.exports;
  if (Zt = 1, process.env.NODE_ENV !== "production") {
    var r = ta(), t = !0;
    rr.exports = /* @__PURE__ */ mo()(r.isElement, t);
  } else
    rr.exports = /* @__PURE__ */ vo()();
  return rr.exports;
}
var yo = /* @__PURE__ */ go();
const le = /* @__PURE__ */ vt(yo);
var aa = /* @__PURE__ */ ea({});
function ke(r) {
  "@babel/helpers - typeof";
  return ke = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ke(r);
}
function bo(r, t) {
  if (ke(r) != "object" || !r) return r;
  var e = r[Symbol.toPrimitive];
  if (e !== void 0) {
    var n = e.call(r, t);
    if (ke(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(r);
}
function _o(r) {
  var t = bo(r, "string");
  return ke(t) == "symbol" ? t : t + "";
}
function dt(r, t, e) {
  return (t = _o(t)) in r ? Object.defineProperty(r, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[t] = e, r;
}
function en(r, t) {
  var e = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(r, o).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function U(r) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? en(Object(e), !0).forEach(function(n) {
      dt(r, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e)) : en(Object(e)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(e, n));
    });
  }
  return r;
}
function wo(r) {
  if (Array.isArray(r)) return r;
}
function Co(r, t) {
  var e = r == null ? null : typeof Symbol != "undefined" && r[Symbol.iterator] || r["@@iterator"];
  if (e != null) {
    var n, o, a, s, u = [], c = !0, l = !1;
    try {
      if (a = (e = e.call(r)).next, t !== 0) for (; !(c = (n = a.call(e)).done) && (u.push(n.value), u.length !== t); c = !0) ;
    } catch (d) {
      l = !0, o = d;
    } finally {
      try {
        if (!c && e.return != null && (s = e.return(), Object(s) !== s)) return;
      } finally {
        if (l) throw o;
      }
    }
    return u;
  }
}
function rn(r, t) {
  (t == null || t > r.length) && (t = r.length);
  for (var e = 0, n = Array(t); e < t; e++) n[e] = r[e];
  return n;
}
function xo(r, t) {
  if (r) {
    if (typeof r == "string") return rn(r, t);
    var e = {}.toString.call(r).slice(8, -1);
    return e === "Object" && r.constructor && (e = r.constructor.name), e === "Map" || e === "Set" ? Array.from(r) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? rn(r, t) : void 0;
  }
}
function Ro() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function oa(r, t) {
  return wo(r) || Co(r, t) || xo(r, t) || Ro();
}
function Oo(r, t) {
  if (r == null) return {};
  var e = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (t.indexOf(n) !== -1) continue;
    e[n] = r[n];
  }
  return e;
}
function ia(r, t) {
  if (r == null) return {};
  var e, n, o = Oo(r, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(r);
    for (n = 0; n < a.length; n++) e = a[n], t.indexOf(e) === -1 && {}.propertyIsEnumerable.call(r, e) && (o[e] = r[e]);
  }
  return o;
}
var xr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var tn;
function So() {
  return tn || (tn = 1, function(r) {
    (function() {
      var t = {}.hasOwnProperty;
      function e() {
        for (var a = "", s = 0; s < arguments.length; s++) {
          var u = arguments[s];
          u && (a = o(a, n(u)));
        }
        return a;
      }
      function n(a) {
        if (typeof a == "string" || typeof a == "number")
          return a;
        if (typeof a != "object")
          return "";
        if (Array.isArray(a))
          return e.apply(null, a);
        if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
          return a.toString();
        var s = "";
        for (var u in a)
          t.call(a, u) && a[u] && (s = o(s, u));
        return s;
      }
      function o(a, s) {
        return s ? a ? a + " " + s : a + s : a;
      }
      r.exports ? (e.default = e, r.exports = e) : window.classNames = e;
    })();
  }(xr)), xr.exports;
}
var Eo = So();
const To = /* @__PURE__ */ vt(Eo);
function Ce(r, t) {
  Io(r) && (r = "100%");
  var e = Po(r);
  return r = t === 360 ? r : Math.min(t, Math.max(0, parseFloat(r))), e && (r = parseInt(String(r * t), 10) / 100), Math.abs(r - t) < 1e-6 ? 1 : (t === 360 ? r = (r < 0 ? r % t + t : r % t) / parseFloat(String(t)) : r = r % t / parseFloat(String(t)), r);
}
function Io(r) {
  return typeof r == "string" && r.indexOf(".") !== -1 && parseFloat(r) === 1;
}
function Po(r) {
  return typeof r == "string" && r.indexOf("%") !== -1;
}
function jo(r) {
  return r = parseFloat(r), (isNaN(r) || r < 0 || r > 1) && (r = 1), r;
}
function nr(r) {
  return r <= 1 ? "".concat(Number(r) * 100, "%") : r;
}
function Rr(r) {
  return r.length === 1 ? "0" + r : String(r);
}
function Ao(r, t, e) {
  return {
    r: Ce(r, 255) * 255,
    g: Ce(t, 255) * 255,
    b: Ce(e, 255) * 255
  };
}
function Or(r, t, e) {
  return e < 0 && (e += 1), e > 1 && (e -= 1), e < 1 / 6 ? r + (t - r) * (6 * e) : e < 1 / 2 ? t : e < 2 / 3 ? r + (t - r) * (2 / 3 - e) * 6 : r;
}
function Do(r, t, e) {
  var n, o, a;
  if (r = Ce(r, 360), t = Ce(t, 100), e = Ce(e, 100), t === 0)
    o = e, a = e, n = e;
  else {
    var s = e < 0.5 ? e * (1 + t) : e + t - e * t, u = 2 * e - s;
    n = Or(u, s, r + 1 / 3), o = Or(u, s, r), a = Or(u, s, r - 1 / 3);
  }
  return { r: n * 255, g: o * 255, b: a * 255 };
}
function Mo(r, t, e) {
  r = Ce(r, 255), t = Ce(t, 255), e = Ce(e, 255);
  var n = Math.max(r, t, e), o = Math.min(r, t, e), a = 0, s = n, u = n - o, c = n === 0 ? 0 : u / n;
  if (n === o)
    a = 0;
  else {
    switch (n) {
      case r:
        a = (t - e) / u + (t < e ? 6 : 0);
        break;
      case t:
        a = (e - r) / u + 2;
        break;
      case e:
        a = (r - t) / u + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: c, v: s };
}
function ko(r, t, e) {
  r = Ce(r, 360) * 6, t = Ce(t, 100), e = Ce(e, 100);
  var n = Math.floor(r), o = r - n, a = e * (1 - t), s = e * (1 - o * t), u = e * (1 - (1 - o) * t), c = n % 6, l = [e, s, a, a, u, e][c], d = [u, e, e, s, a, a][c], f = [a, a, u, e, e, s][c];
  return { r: l * 255, g: d * 255, b: f * 255 };
}
function No(r, t, e, n) {
  var o = [
    Rr(Math.round(r).toString(16)),
    Rr(Math.round(t).toString(16)),
    Rr(Math.round(e).toString(16))
  ];
  return o.join("");
}
function nn(r) {
  return ye(r) / 255;
}
function ye(r) {
  return parseInt(r, 16);
}
var an = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Ve(r) {
  var t = { r: 0, g: 0, b: 0 }, e = 1, n = null, o = null, a = null, s = !1, u = !1;
  return typeof r == "string" && (r = Fo(r)), typeof r == "object" && (Te(r.r) && Te(r.g) && Te(r.b) ? (t = Ao(r.r, r.g, r.b), s = !0, u = String(r.r).substr(-1) === "%" ? "prgb" : "rgb") : Te(r.h) && Te(r.s) && Te(r.v) ? (n = nr(r.s), o = nr(r.v), t = ko(r.h, n, o), s = !0, u = "hsv") : Te(r.h) && Te(r.s) && Te(r.l) && (n = nr(r.s), a = nr(r.l), t = Do(r.h, n, a), s = !0, u = "hsl"), Object.prototype.hasOwnProperty.call(r, "a") && (e = r.a)), e = jo(e), {
    ok: s,
    format: r.format || u,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: e
  };
}
var Lo = "[-\\+]?\\d+%?", Bo = "[-\\+]?\\d*\\.\\d+%?", Ae = "(?:".concat(Bo, ")|(?:").concat(Lo, ")"), Sr = "[\\s|\\(]+(".concat(Ae, ")[,|\\s]+(").concat(Ae, ")[,|\\s]+(").concat(Ae, ")\\s*\\)?"), Er = "[\\s|\\(]+(".concat(Ae, ")[,|\\s]+(").concat(Ae, ")[,|\\s]+(").concat(Ae, ")[,|\\s]+(").concat(Ae, ")\\s*\\)?"), Oe = {
  CSS_UNIT: new RegExp(Ae),
  rgb: new RegExp("rgb" + Sr),
  rgba: new RegExp("rgba" + Er),
  hsl: new RegExp("hsl" + Sr),
  hsla: new RegExp("hsla" + Er),
  hsv: new RegExp("hsv" + Sr),
  hsva: new RegExp("hsva" + Er),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function Fo(r) {
  if (r = r.trim().toLowerCase(), r.length === 0)
    return !1;
  var t = !1;
  if (an[r])
    r = an[r], t = !0;
  else if (r === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var e = Oe.rgb.exec(r);
  return e ? { r: e[1], g: e[2], b: e[3] } : (e = Oe.rgba.exec(r), e ? { r: e[1], g: e[2], b: e[3], a: e[4] } : (e = Oe.hsl.exec(r), e ? { h: e[1], s: e[2], l: e[3] } : (e = Oe.hsla.exec(r), e ? { h: e[1], s: e[2], l: e[3], a: e[4] } : (e = Oe.hsv.exec(r), e ? { h: e[1], s: e[2], v: e[3] } : (e = Oe.hsva.exec(r), e ? { h: e[1], s: e[2], v: e[3], a: e[4] } : (e = Oe.hex8.exec(r), e ? {
    r: ye(e[1]),
    g: ye(e[2]),
    b: ye(e[3]),
    a: nn(e[4]),
    format: t ? "name" : "hex8"
  } : (e = Oe.hex6.exec(r), e ? {
    r: ye(e[1]),
    g: ye(e[2]),
    b: ye(e[3]),
    format: t ? "name" : "hex"
  } : (e = Oe.hex4.exec(r), e ? {
    r: ye(e[1] + e[1]),
    g: ye(e[2] + e[2]),
    b: ye(e[3] + e[3]),
    a: nn(e[4] + e[4]),
    format: t ? "name" : "hex8"
  } : (e = Oe.hex3.exec(r), e ? {
    r: ye(e[1] + e[1]),
    g: ye(e[2] + e[2]),
    b: ye(e[3] + e[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function Te(r) {
  return !!Oe.CSS_UNIT.exec(String(r));
}
var ar = 2, on = 0.16, Ho = 0.05, Wo = 0.05, Uo = 0.15, sa = 5, ca = 4, qo = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function sn(r) {
  var t = r.r, e = r.g, n = r.b, o = Mo(t, e, n);
  return {
    h: o.h * 360,
    s: o.s,
    v: o.v
  };
}
function or(r) {
  var t = r.r, e = r.g, n = r.b;
  return "#".concat(No(t, e, n));
}
function zo(r, t, e) {
  var n = e / 100, o = {
    r: (t.r - r.r) * n + r.r,
    g: (t.g - r.g) * n + r.g,
    b: (t.b - r.b) * n + r.b
  };
  return o;
}
function cn(r, t, e) {
  var n;
  return Math.round(r.h) >= 60 && Math.round(r.h) <= 240 ? n = e ? Math.round(r.h) - ar * t : Math.round(r.h) + ar * t : n = e ? Math.round(r.h) + ar * t : Math.round(r.h) - ar * t, n < 0 ? n += 360 : n >= 360 && (n -= 360), n;
}
function un(r, t, e) {
  if (r.h === 0 && r.s === 0)
    return r.s;
  var n;
  return e ? n = r.s - on * t : t === ca ? n = r.s + on : n = r.s + Ho * t, n > 1 && (n = 1), e && t === sa && n > 0.1 && (n = 0.1), n < 0.06 && (n = 0.06), Number(n.toFixed(2));
}
function ln(r, t, e) {
  var n;
  return e ? n = r.v + Wo * t : n = r.v - Uo * t, n > 1 && (n = 1), Number(n.toFixed(2));
}
function ft(r) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = [], n = Ve(r), o = sa; o > 0; o -= 1) {
    var a = sn(n), s = or(Ve({
      h: cn(a, o, !0),
      s: un(a, o, !0),
      v: ln(a, o, !0)
    }));
    e.push(s);
  }
  e.push(or(n));
  for (var u = 1; u <= ca; u += 1) {
    var c = sn(n), l = or(Ve({
      h: cn(c, u),
      s: un(c, u),
      v: ln(c, u)
    }));
    e.push(l);
  }
  return t.theme === "dark" ? qo.map(function(d) {
    var f = d.index, y = d.opacity, m = or(zo(Ve(t.backgroundColor || "#141414"), Ve(e[f]), y * 100));
    return m;
  }) : e;
}
var Tr = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1890FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, Ir = {}, Pr = {};
Object.keys(Tr).forEach(function(r) {
  Ir[r] = ft(Tr[r]), Ir[r].primary = Ir[r][5], Pr[r] = ft(Tr[r], {
    theme: "dark",
    backgroundColor: "#141414"
  }), Pr[r].primary = Pr[r][5];
});
var pt = {}, yt = [], Yo = function(t) {
  yt.push(t);
};
function Vo(r, t) {
  if (process.env.NODE_ENV !== "production" && !r && console !== void 0) {
    var e = yt.reduce(function(n, o) {
      return o(n != null ? n : "", "warning");
    }, t);
    e && console.error("Warning: ".concat(e));
  }
}
function Ko(r, t) {
  if (process.env.NODE_ENV !== "production" && !r && console !== void 0) {
    var e = yt.reduce(function(n, o) {
      return o(n != null ? n : "", "note");
    }, t);
    e && console.warn("Note: ".concat(e));
  }
}
function $o() {
  pt = {};
}
function ua(r, t, e) {
  !t && !pt[e] && (r(!1, e), pt[e] = !0);
}
function ur(r, t) {
  ua(Vo, r, t);
}
function Go(r, t) {
  ua(Ko, r, t);
}
ur.preMessage = Yo;
ur.resetWarned = $o;
ur.noteOnce = Go;
function Qo() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}
function Xo(r, t) {
  if (!r)
    return !1;
  if (r.contains)
    return r.contains(t);
  for (var e = t; e; ) {
    if (e === r)
      return !0;
    e = e.parentNode;
  }
  return !1;
}
var dn = "data-rc-order", fn = "data-rc-priority", Jo = "rc-util-key", ht = /* @__PURE__ */ new Map();
function la() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = r.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : Jo;
}
function bt(r) {
  if (r.attachTo)
    return r.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function Zo(r) {
  return r === "queue" ? "prependQueue" : r ? "prepend" : "append";
}
function _t(r) {
  return Array.from((ht.get(r) || r).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function da(r) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!Qo())
    return null;
  var e = t.csp, n = t.prepend, o = t.priority, a = o === void 0 ? 0 : o, s = Zo(n), u = s === "prependQueue", c = document.createElement("style");
  c.setAttribute(dn, s), u && a && c.setAttribute(fn, "".concat(a)), e != null && e.nonce && (c.nonce = e == null ? void 0 : e.nonce), c.innerHTML = r;
  var l = bt(t), d = l.firstChild;
  if (n) {
    if (u) {
      var f = (t.styles || _t(l)).filter(function(y) {
        if (!["prepend", "prependQueue"].includes(y.getAttribute(dn)))
          return !1;
        var m = Number(y.getAttribute(fn) || 0);
        return a >= m;
      });
      if (f.length)
        return l.insertBefore(c, f[f.length - 1].nextSibling), c;
    }
    l.insertBefore(c, d);
  } else
    l.appendChild(c);
  return c;
}
function ei(r) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = bt(t);
  return (t.styles || _t(e)).find(function(n) {
    return n.getAttribute(la(t)) === r;
  });
}
function ri(r, t) {
  var e = ht.get(r);
  if (!e || !Xo(document, e)) {
    var n = da("", t), o = n.parentNode;
    ht.set(r, o), r.removeChild(n);
  }
}
function ti(r, t) {
  var e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = bt(e), o = _t(n), a = U(U({}, e), {}, {
    styles: o
  });
  ri(n, a);
  var s = ei(t, a);
  if (s) {
    var u, c;
    if ((u = a.csp) !== null && u !== void 0 && u.nonce && s.nonce !== ((c = a.csp) === null || c === void 0 ? void 0 : c.nonce)) {
      var l;
      s.nonce = (l = a.csp) === null || l === void 0 ? void 0 : l.nonce;
    }
    return s.innerHTML !== r && (s.innerHTML = r), s;
  }
  var d = da(r, a);
  return d.setAttribute(la(a), t), d;
}
var jr, pn;
function ni() {
  if (pn) return jr;
  pn = 1;
  var r = typeof Ze == "object" && Ze && Ze.Object === Object && Ze;
  return jr = r, jr;
}
var Ar, hn;
function ai() {
  if (hn) return Ar;
  hn = 1;
  var r = ni(), t = typeof self == "object" && self && self.Object === Object && self, e = r || t || Function("return this")();
  return Ar = e, Ar;
}
var Dr, mn;
function wt() {
  if (mn) return Dr;
  mn = 1;
  var r = ai(), t = r.Symbol;
  return Dr = t, Dr;
}
var Mr, vn;
function oi() {
  if (vn) return Mr;
  vn = 1;
  function r(t, e) {
    for (var n = -1, o = t == null ? 0 : t.length, a = Array(o); ++n < o; )
      a[n] = e(t[n], n, t);
    return a;
  }
  return Mr = r, Mr;
}
var kr, gn;
function ii() {
  if (gn) return kr;
  gn = 1;
  var r = Array.isArray;
  return kr = r, kr;
}
var Nr, yn;
function si() {
  if (yn) return Nr;
  yn = 1;
  var r = wt(), t = Object.prototype, e = t.hasOwnProperty, n = t.toString, o = r ? r.toStringTag : void 0;
  function a(s) {
    var u = e.call(s, o), c = s[o];
    try {
      s[o] = void 0;
      var l = !0;
    } catch (f) {
    }
    var d = n.call(s);
    return l && (u ? s[o] = c : delete s[o]), d;
  }
  return Nr = a, Nr;
}
var Lr, bn;
function ci() {
  if (bn) return Lr;
  bn = 1;
  var r = Object.prototype, t = r.toString;
  function e(n) {
    return t.call(n);
  }
  return Lr = e, Lr;
}
var Br, _n;
function ui() {
  if (_n) return Br;
  _n = 1;
  var r = wt(), t = si(), e = ci(), n = "[object Null]", o = "[object Undefined]", a = r ? r.toStringTag : void 0;
  function s(u) {
    return u == null ? u === void 0 ? o : n : a && a in Object(u) ? t(u) : e(u);
  }
  return Br = s, Br;
}
var Fr, wn;
function li() {
  if (wn) return Fr;
  wn = 1;
  function r(t) {
    return t != null && typeof t == "object";
  }
  return Fr = r, Fr;
}
var Hr, Cn;
function di() {
  if (Cn) return Hr;
  Cn = 1;
  var r = ui(), t = li(), e = "[object Symbol]";
  function n(o) {
    return typeof o == "symbol" || t(o) && r(o) == e;
  }
  return Hr = n, Hr;
}
var Wr, xn;
function fi() {
  if (xn) return Wr;
  xn = 1;
  var r = wt(), t = oi(), e = ii(), n = di(), o = r ? r.prototype : void 0, a = o ? o.toString : void 0;
  function s(u) {
    if (typeof u == "string")
      return u;
    if (e(u))
      return t(u, s) + "";
    if (n(u))
      return a ? a.call(u) : "";
    var c = u + "";
    return c == "0" && 1 / u == -1 / 0 ? "-0" : c;
  }
  return Wr = s, Wr;
}
var Ur, Rn;
function lr() {
  if (Rn) return Ur;
  Rn = 1;
  var r = fi();
  function t(e) {
    return e == null ? "" : r(e);
  }
  return Ur = t, Ur;
}
var qr, On;
function pi() {
  if (On) return qr;
  On = 1;
  function r(t, e, n) {
    var o = -1, a = t.length;
    e < 0 && (e = -e > a ? 0 : a + e), n = n > a ? a : n, n < 0 && (n += a), a = e > n ? 0 : n - e >>> 0, e >>>= 0;
    for (var s = Array(a); ++o < a; )
      s[o] = t[o + e];
    return s;
  }
  return qr = r, qr;
}
var zr, Sn;
function hi() {
  if (Sn) return zr;
  Sn = 1;
  var r = pi();
  function t(e, n, o) {
    var a = e.length;
    return o = o === void 0 ? a : o, !n && o >= a ? e : r(e, n, o);
  }
  return zr = t, zr;
}
var Yr, En;
function fa() {
  if (En) return Yr;
  En = 1;
  var r = "\\ud800-\\udfff", t = "\\u0300-\\u036f", e = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", o = t + e + n, a = "\\ufe0e\\ufe0f", s = "\\u200d", u = RegExp("[" + s + r + o + a + "]");
  function c(l) {
    return u.test(l);
  }
  return Yr = c, Yr;
}
var Vr, Tn;
function mi() {
  if (Tn) return Vr;
  Tn = 1;
  function r(t) {
    return t.split("");
  }
  return Vr = r, Vr;
}
var Kr, In;
function vi() {
  if (In) return Kr;
  In = 1;
  var r = "\\ud800-\\udfff", t = "\\u0300-\\u036f", e = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", o = t + e + n, a = "\\ufe0e\\ufe0f", s = "[" + r + "]", u = "[" + o + "]", c = "\\ud83c[\\udffb-\\udfff]", l = "(?:" + u + "|" + c + ")", d = "[^" + r + "]", f = "(?:\\ud83c[\\udde6-\\uddff]){2}", y = "[\\ud800-\\udbff][\\udc00-\\udfff]", m = "\\u200d", x = l + "?", C = "[" + a + "]?", R = "(?:" + m + "(?:" + [d, f, y].join("|") + ")" + C + x + ")*", S = C + x + R, k = "(?:" + [d + u + "?", u, f, y, s].join("|") + ")", D = RegExp(c + "(?=" + c + ")|" + k + S, "g");
  function T(g) {
    return g.match(D) || [];
  }
  return Kr = T, Kr;
}
var $r, Pn;
function gi() {
  if (Pn) return $r;
  Pn = 1;
  var r = mi(), t = fa(), e = vi();
  function n(o) {
    return t(o) ? e(o) : r(o);
  }
  return $r = n, $r;
}
var Gr, jn;
function yi() {
  if (jn) return Gr;
  jn = 1;
  var r = hi(), t = fa(), e = gi(), n = lr();
  function o(a) {
    return function(s) {
      s = n(s);
      var u = t(s) ? e(s) : void 0, c = u ? u[0] : s.charAt(0), l = u ? r(u, 1).join("") : s.slice(1);
      return c[a]() + l;
    };
  }
  return Gr = o, Gr;
}
var Qr, An;
function bi() {
  if (An) return Qr;
  An = 1;
  var r = yi(), t = r("toUpperCase");
  return Qr = t, Qr;
}
var Xr, Dn;
function _i() {
  if (Dn) return Xr;
  Dn = 1;
  var r = lr(), t = bi();
  function e(n) {
    return t(r(n).toLowerCase());
  }
  return Xr = e, Xr;
}
var Jr, Mn;
function wi() {
  if (Mn) return Jr;
  Mn = 1;
  function r(t, e, n, o) {
    var a = -1, s = t == null ? 0 : t.length;
    for (o && s && (n = t[++a]); ++a < s; )
      n = e(n, t[a], a, t);
    return n;
  }
  return Jr = r, Jr;
}
var Zr, kn;
function Ci() {
  if (kn) return Zr;
  kn = 1;
  function r(t) {
    return function(e) {
      return t == null ? void 0 : t[e];
    };
  }
  return Zr = r, Zr;
}
var et, Nn;
function xi() {
  if (Nn) return et;
  Nn = 1;
  var r = Ci(), t = {
    // Latin-1 Supplement block.
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    Ç: "C",
    ç: "c",
    Ð: "D",
    ð: "d",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    Ñ: "N",
    ñ: "n",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ý: "Y",
    ý: "y",
    ÿ: "y",
    Æ: "Ae",
    æ: "ae",
    Þ: "Th",
    þ: "th",
    ß: "ss",
    // Latin Extended-A block.
    Ā: "A",
    Ă: "A",
    Ą: "A",
    ā: "a",
    ă: "a",
    ą: "a",
    Ć: "C",
    Ĉ: "C",
    Ċ: "C",
    Č: "C",
    ć: "c",
    ĉ: "c",
    ċ: "c",
    č: "c",
    Ď: "D",
    Đ: "D",
    ď: "d",
    đ: "d",
    Ē: "E",
    Ĕ: "E",
    Ė: "E",
    Ę: "E",
    Ě: "E",
    ē: "e",
    ĕ: "e",
    ė: "e",
    ę: "e",
    ě: "e",
    Ĝ: "G",
    Ğ: "G",
    Ġ: "G",
    Ģ: "G",
    ĝ: "g",
    ğ: "g",
    ġ: "g",
    ģ: "g",
    Ĥ: "H",
    Ħ: "H",
    ĥ: "h",
    ħ: "h",
    Ĩ: "I",
    Ī: "I",
    Ĭ: "I",
    Į: "I",
    İ: "I",
    ĩ: "i",
    ī: "i",
    ĭ: "i",
    į: "i",
    ı: "i",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    ĸ: "k",
    Ĺ: "L",
    Ļ: "L",
    Ľ: "L",
    Ŀ: "L",
    Ł: "L",
    ĺ: "l",
    ļ: "l",
    ľ: "l",
    ŀ: "l",
    ł: "l",
    Ń: "N",
    Ņ: "N",
    Ň: "N",
    Ŋ: "N",
    ń: "n",
    ņ: "n",
    ň: "n",
    ŋ: "n",
    Ō: "O",
    Ŏ: "O",
    Ő: "O",
    ō: "o",
    ŏ: "o",
    ő: "o",
    Ŕ: "R",
    Ŗ: "R",
    Ř: "R",
    ŕ: "r",
    ŗ: "r",
    ř: "r",
    Ś: "S",
    Ŝ: "S",
    Ş: "S",
    Š: "S",
    ś: "s",
    ŝ: "s",
    ş: "s",
    š: "s",
    Ţ: "T",
    Ť: "T",
    Ŧ: "T",
    ţ: "t",
    ť: "t",
    ŧ: "t",
    Ũ: "U",
    Ū: "U",
    Ŭ: "U",
    Ů: "U",
    Ű: "U",
    Ų: "U",
    ũ: "u",
    ū: "u",
    ŭ: "u",
    ů: "u",
    ű: "u",
    ų: "u",
    Ŵ: "W",
    ŵ: "w",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Ź: "Z",
    Ż: "Z",
    Ž: "Z",
    ź: "z",
    ż: "z",
    ž: "z",
    Ĳ: "IJ",
    ĳ: "ij",
    Œ: "Oe",
    œ: "oe",
    ŉ: "'n",
    ſ: "s"
  }, e = r(t);
  return et = e, et;
}
var rt, Ln;
function Ri() {
  if (Ln) return rt;
  Ln = 1;
  var r = xi(), t = lr(), e = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, n = "\\u0300-\\u036f", o = "\\ufe20-\\ufe2f", a = "\\u20d0-\\u20ff", s = n + o + a, u = "[" + s + "]", c = RegExp(u, "g");
  function l(d) {
    return d = t(d), d && d.replace(e, r).replace(c, "");
  }
  return rt = l, rt;
}
var tt, Bn;
function Oi() {
  if (Bn) return tt;
  Bn = 1;
  var r = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function t(e) {
    return e.match(r) || [];
  }
  return tt = t, tt;
}
var nt, Fn;
function Si() {
  if (Fn) return nt;
  Fn = 1;
  var r = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function t(e) {
    return r.test(e);
  }
  return nt = t, nt;
}
var at, Hn;
function Ei() {
  if (Hn) return at;
  Hn = 1;
  var r = "\\ud800-\\udfff", t = "\\u0300-\\u036f", e = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", o = t + e + n, a = "\\u2700-\\u27bf", s = "a-z\\xdf-\\xf6\\xf8-\\xff", u = "\\xac\\xb1\\xd7\\xf7", c = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", l = "\\u2000-\\u206f", d = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", f = "A-Z\\xc0-\\xd6\\xd8-\\xde", y = "\\ufe0e\\ufe0f", m = u + c + l + d, x = "['’]", C = "[" + m + "]", R = "[" + o + "]", S = "\\d+", k = "[" + a + "]", D = "[" + s + "]", T = "[^" + r + m + S + a + s + f + "]", g = "\\ud83c[\\udffb-\\udfff]", J = "(?:" + R + "|" + g + ")", ce = "[^" + r + "]", $ = "(?:\\ud83c[\\udde6-\\uddff]){2}", ne = "[\\ud800-\\udbff][\\udc00-\\udfff]", ie = "[" + f + "]", ve = "\\u200d", ge = "(?:" + D + "|" + T + ")", se = "(?:" + ie + "|" + T + ")", ee = "(?:" + x + "(?:d|ll|m|re|s|t|ve))?", de = "(?:" + x + "(?:D|LL|M|RE|S|T|VE))?", re = J + "?", fe = "[" + y + "]?", V = "(?:" + ve + "(?:" + [ce, $, ne].join("|") + ")" + fe + re + ")*", G = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", p = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", b = fe + re + V, M = "(?:" + [k, $, ne].join("|") + ")" + b, P = RegExp([
    ie + "?" + D + "+" + ee + "(?=" + [C, ie, "$"].join("|") + ")",
    se + "+" + de + "(?=" + [C, ie + ge, "$"].join("|") + ")",
    ie + "?" + ge + "+" + ee,
    ie + "+" + de,
    p,
    G,
    S,
    M
  ].join("|"), "g");
  function E(L) {
    return L.match(P) || [];
  }
  return at = E, at;
}
var ot, Wn;
function Ti() {
  if (Wn) return ot;
  Wn = 1;
  var r = Oi(), t = Si(), e = lr(), n = Ei();
  function o(a, s, u) {
    return a = e(a), s = u ? void 0 : s, s === void 0 ? t(a) ? n(a) : r(a) : a.match(s) || [];
  }
  return ot = o, ot;
}
var it, Un;
function Ii() {
  if (Un) return it;
  Un = 1;
  var r = wi(), t = Ri(), e = Ti(), n = "['’]", o = RegExp(n, "g");
  function a(s) {
    return function(u) {
      return r(e(t(u).replace(o, "")), s, "");
    };
  }
  return it = a, it;
}
var st, qn;
function Pi() {
  if (qn) return st;
  qn = 1;
  var r = _i(), t = Ii(), e = t(function(n, o, a) {
    return o = o.toLowerCase(), n + (a ? r(o) : o);
  });
  return st = e, st;
}
var ji = Pi();
const Ai = /* @__PURE__ */ vt(ji);
function Di(r, t) {
  ur(r, "[@ant-design/icons] ".concat(t));
}
function zn(r) {
  return ke(r) === "object" && typeof r.name == "string" && typeof r.theme == "string" && (ke(r.icon) === "object" || typeof r.icon == "function");
}
function Yn() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(r).reduce(function(t, e) {
    var n = r[e];
    switch (e) {
      case "class":
        t.className = n, delete t.class;
        break;
      default:
        delete t[e], t[Ai(e)] = n;
    }
    return t;
  }, {});
}
function mt(r, t, e) {
  return e ? /* @__PURE__ */ W.createElement(r.tag, U(U({
    key: t
  }, Yn(r.attrs)), e), (r.children || []).map(function(n, o) {
    return mt(n, "".concat(t, "-").concat(r.tag, "-").concat(o));
  })) : /* @__PURE__ */ W.createElement(r.tag, U({
    key: t
  }, Yn(r.attrs)), (r.children || []).map(function(n, o) {
    return mt(n, "".concat(t, "-").concat(r.tag, "-").concat(o));
  }));
}
function pa(r) {
  return ft(r)[0];
}
function ha(r) {
  return r ? Array.isArray(r) ? r : [r] : [];
}
var Mi = `
.anticon {
  display: inline-flex;
  alignItems: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, ki = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Mi, e = Ge(aa), n = e.csp;
  $e(function() {
    ti(t, "@ant-design-icons", {
      prepend: !0,
      csp: n
    });
  }, []);
}, Ni = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], Ke = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function Li(r) {
  var t = r.primaryColor, e = r.secondaryColor;
  Ke.primaryColor = t, Ke.secondaryColor = e || pa(t), Ke.calculated = !!e;
}
function Bi() {
  return U({}, Ke);
}
var Ue = function(t) {
  var e = t.icon, n = t.className, o = t.onClick, a = t.style, s = t.primaryColor, u = t.secondaryColor, c = ia(t, Ni), l = Ke;
  if (s && (l = {
    primaryColor: s,
    secondaryColor: u || pa(s)
  }), ki(), Di(zn(e), "icon should be icon definiton, but got ".concat(e)), !zn(e))
    return null;
  var d = e;
  return d && typeof d.icon == "function" && (d = U(U({}, d), {}, {
    icon: d.icon(l.primaryColor, l.secondaryColor)
  })), mt(d.icon, "svg-".concat(d.name), U({
    className: n,
    onClick: o,
    style: a,
    "data-icon": d.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, c));
};
Ue.displayName = "IconReact";
Ue.getTwoToneColors = Bi;
Ue.setTwoToneColors = Li;
function ma(r) {
  var t = ha(r), e = oa(t, 2), n = e[0], o = e[1];
  return Ue.setTwoToneColors({
    primaryColor: n,
    secondaryColor: o
  });
}
function Fi() {
  var r = Ue.getTwoToneColors();
  return r.calculated ? [r.primaryColor, r.secondaryColor] : r.primaryColor;
}
var Hi = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
ma("#1890ff");
var be = /* @__PURE__ */ X.forwardRef(function(r, t) {
  var e = r.className, n = r.icon, o = r.spin, a = r.rotate, s = r.tabIndex, u = r.onClick, c = r.twoToneColor, l = ia(r, Hi), d = X.useContext(aa), f = d.prefixCls, y = f === void 0 ? "anticon" : f, m = d.rootClassName, x = To(m, y, dt(dt({}, "".concat(y, "-").concat(n.name), !!n.name), "".concat(y, "-spin"), !!o || n.name === "loading"), e), C = s;
  C === void 0 && u && (C = -1);
  var R = a ? {
    msTransform: "rotate(".concat(a, "deg)"),
    transform: "rotate(".concat(a, "deg)")
  } : void 0, S = ha(c), k = oa(S, 2), D = k[0], T = k[1];
  return /* @__PURE__ */ X.createElement("span", U(U({
    role: "img",
    "aria-label": n.name
  }, l), {}, {
    ref: t,
    tabIndex: C,
    onClick: u,
    className: x
  }), /* @__PURE__ */ X.createElement(Ue, {
    icon: n,
    primaryColor: D,
    secondaryColor: T,
    style: R
  }));
});
be.displayName = "AntdIcon";
be.getTwoToneColor = Fi;
be.setTwoToneColor = ma;
var Wi = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, name: "arrow-left", theme: "outlined" }, Ui = function(t, e) {
  return /* @__PURE__ */ X.createElement(be, U(U({}, t), {}, {
    ref: e,
    icon: Wi
  }));
}, Ct = /* @__PURE__ */ X.forwardRef(Ui);
process.env.NODE_ENV !== "production" && (Ct.displayName = "ArrowLeftOutlined");
var qi = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "border", theme: "outlined" }, zi = function(t, e) {
  return /* @__PURE__ */ X.createElement(be, U(U({}, t), {}, {
    ref: e,
    icon: qi
  }));
}, va = /* @__PURE__ */ X.forwardRef(zi);
process.env.NODE_ENV !== "production" && (va.displayName = "BorderOutlined");
var Yi = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z" } }] }, name: "bulb", theme: "outlined" }, Vi = function(t, e) {
  return /* @__PURE__ */ X.createElement(be, U(U({}, t), {}, {
    ref: e,
    icon: Yi
  }));
}, ga = /* @__PURE__ */ X.forwardRef(Vi);
process.env.NODE_ENV !== "production" && (ga.displayName = "BulbOutlined");
var Ki = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M864 248H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z" } }] }, name: "camera", theme: "outlined" }, $i = function(t, e) {
  return /* @__PURE__ */ X.createElement(be, U(U({}, t), {}, {
    ref: e,
    icon: Ki
  }));
}, ir = /* @__PURE__ */ X.forwardRef($i);
process.env.NODE_ENV !== "production" && (ir.displayName = "CameraOutlined");
var Gi = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" }, Qi = function(t, e) {
  return /* @__PURE__ */ X.createElement(be, U(U({}, t), {}, {
    ref: e,
    icon: Gi
  }));
}, ya = /* @__PURE__ */ X.forwardRef(Qi);
process.env.NODE_ENV !== "production" && (ya.displayName = "CheckOutlined");
var Xi = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z" } }] }, name: "idcard", theme: "outlined" }, Ji = function(t, e) {
  return /* @__PURE__ */ X.createElement(be, U(U({}, t), {}, {
    ref: e,
    icon: Xi
  }));
}, ba = /* @__PURE__ */ X.forwardRef(Ji);
process.env.NODE_ENV !== "production" && (ba.displayName = "IdcardOutlined");
var Zi = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, name: "info-circle", theme: "outlined" }, es = function(t, e) {
  return /* @__PURE__ */ X.createElement(be, U(U({}, t), {}, {
    ref: e,
    icon: Zi
  }));
}, _a = /* @__PURE__ */ X.forwardRef(es);
process.env.NODE_ENV !== "production" && (_a.displayName = "InfoCircleOutlined");
var rs = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z" } }] }, name: "picture", theme: "outlined" }, ts = function(t, e) {
  return /* @__PURE__ */ X.createElement(be, U(U({}, t), {}, {
    ref: e,
    icon: rs
  }));
}, wa = /* @__PURE__ */ X.forwardRef(ts);
process.env.NODE_ENV !== "production" && (wa.displayName = "PictureOutlined");
var ns = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" }, as = function(t, e) {
  return /* @__PURE__ */ X.createElement(be, U(U({}, t), {}, {
    ref: e,
    icon: ns
  }));
}, Ca = /* @__PURE__ */ X.forwardRef(as);
process.env.NODE_ENV !== "production" && (Ca.displayName = "RightOutlined");
var os = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 00-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 00-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z" } }] }, name: "undo", theme: "outlined" }, is = function(t, e) {
  return /* @__PURE__ */ X.createElement(be, U(U({}, t), {}, {
    ref: e,
    icon: os
  }));
}, xa = /* @__PURE__ */ X.forwardRef(is);
process.env.NODE_ENV !== "production" && (xa.displayName = "UndoOutlined");
const ss = "OcrScanner-module__ocrScanner__VwgS1", cs = "OcrScanner-module__stepContent__a308w", us = "OcrScanner-module__documentTypeSection__rUvKn", ls = "OcrScanner-module__sectionIcon__AMiNc", ds = "OcrScanner-module__captureSection__0OaE1", fs = "OcrScanner-module__sourceButtons__txeZN", ps = "OcrScanner-module__previewImage__WOzXS", hs = "OcrScanner-module__stepsAction__dGUPI", ms = "OcrScanner-module__documentOption__C0UtP", vs = "OcrScanner-module__documentOptionLeft__iie3C", gs = "OcrScanner-module__documentIcon__rTv38", ys = "OcrScanner-module__documentOptionRight__rQovP", bs = "OcrScanner-module__countryLabel__Ottn4", _s = "OcrScanner-module__ocrDocumentSideItems__ydbaR", ws = "OcrScanner-module__ocrDocumentSideItem__8-elL", Cs = "OcrScanner-module__documentPlaceholder__lHEVI", xs = "OcrScanner-module__placeholderContent__oIHGL", Rs = "OcrScanner-module__front__-sHPu", Os = "OcrScanner-module__back__lgs8Q", Ss = "OcrScanner-module__uploadedImage__nALB6", Es = "OcrScanner-module__uploadOptions__PDWsF", Ts = "OcrScanner-module__uploadButton__M5K5G", Is = "OcrScanner-module__sideSelection__ERkry", Ps = "OcrScanner-module__sideOption__NCnO8", js = "OcrScanner-module__completed__S7Kvj", As = "OcrScanner-module__sideContent__ztEfQ", Ds = "OcrScanner-module__checkMark__X9tY2", Ms = "OcrScanner-module__captureOptions__LsIGH", ks = "OcrScanner-module__confirmationModalContent__hCj6v", Ns = "OcrScanner-module__capturedImagesPreview__WkZTe", Ls = "OcrScanner-module__previewItem__O5FNN", Bs = "OcrScanner-module__stepsContent__Mn-Md", Fs = "OcrScanner-module__documentSelectionStep__xJqnX", Hs = "OcrScanner-module__documentSides__eI9XH", Ws = "OcrScanner-module__title__r4cIO", Us = "OcrScanner-module__antModalContent__mcGnQ", qs = "OcrScanner-module__antModalHeader__KWPgV", zs = "OcrScanner-module__antModalTitle__ZoMEH", Ys = "OcrScanner-module__antModalClose__fsxP2", Vs = "OcrScanner-module__antStepsItemFinish__fgxOI", Ks = "OcrScanner-module__antStepsItemProcess__v7Ilv", Z = {
  ocrScanner: ss,
  stepContent: cs,
  documentTypeSection: us,
  sectionIcon: ls,
  captureSection: ds,
  sourceButtons: fs,
  previewImage: ps,
  stepsAction: hs,
  documentOption: ms,
  documentOptionLeft: vs,
  documentIcon: gs,
  documentOptionRight: ys,
  countryLabel: bs,
  ocrDocumentSideItems: _s,
  ocrDocumentSideItem: ws,
  documentPlaceholder: Cs,
  placeholderContent: xs,
  front: Rs,
  back: Os,
  uploadedImage: Ss,
  uploadOptions: Es,
  uploadButton: Ts,
  sideSelection: Is,
  sideOption: Ps,
  completed: js,
  sideContent: As,
  checkMark: Ds,
  captureOptions: Ms,
  confirmationModalContent: ks,
  capturedImagesPreview: Ns,
  previewItem: Ls,
  stepsContent: Bs,
  documentSelectionStep: Fs,
  documentSides: Hs,
  title: Ws,
  antModalContent: Us,
  antModalHeader: qs,
  antModalTitle: zs,
  antModalClose: Ys,
  antStepsItemFinish: Vs,
  antStepsItemProcess: Ks
};
var $s = Object.defineProperty, Gs = (r, t, e) => t in r ? $s(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, Q = (r, t, e) => Gs(r, typeof t != "symbol" ? t + "" : t, e);
const sr = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  unit: "px"
}, Fe = (r, t, e) => Math.min(Math.max(r, t), e), Qs = (...r) => r.filter((t) => t && typeof t == "string").join(" "), Vn = (r, t) => r === t || r.width === t.width && r.height === t.height && r.x === t.x && r.y === t.y && r.unit === t.unit;
function He(r, t, e) {
  return r.unit === "%" ? Je(xe(xe({}, sr), r), { unit: "%" }) : {
    unit: "%",
    x: r.x ? r.x / t * 100 : 0,
    y: r.y ? r.y / e * 100 : 0,
    width: r.width ? r.width / t * 100 : 0,
    height: r.height ? r.height / e * 100 : 0
  };
}
function Ie(r, t, e) {
  return r.unit ? r.unit === "px" ? Je(xe(xe({}, sr), r), { unit: "px" }) : {
    unit: "px",
    x: r.x ? r.x * t / 100 : 0,
    y: r.y ? r.y * e / 100 : 0,
    width: r.width ? r.width * t / 100 : 0,
    height: r.height ? r.height * e / 100 : 0
  } : Je(xe(xe({}, sr), r), { unit: "px" });
}
function Kn(r, t, e, n, o, a = 0, s = 0, u = n, c = o) {
  const l = xe({}, r);
  let d = Math.min(a, n), f = Math.min(s, o), y = Math.min(u, n), m = Math.min(c, o);
  t && (t > 1 ? (d = s ? s * t : d, f = d / t, y = u * t) : (f = a ? a / t : f, d = f * t, m = c / t)), l.y < 0 && (l.height = Math.max(l.height + l.y, f), l.y = 0), l.x < 0 && (l.width = Math.max(l.width + l.x, d), l.x = 0);
  const x = n - (l.x + l.width);
  x < 0 && (l.x = Math.min(l.x, n - d), l.width += x);
  const C = o - (l.y + l.height);
  if (C < 0 && (l.y = Math.min(l.y, o - f), l.height += C), l.width < d && ((e === "sw" || e == "nw") && (l.x -= d - l.width), l.width = d), l.height < f && ((e === "nw" || e == "ne") && (l.y -= f - l.height), l.height = f), l.width > y && ((e === "sw" || e == "nw") && (l.x -= y - l.width), l.width = y), l.height > m && ((e === "nw" || e == "ne") && (l.y -= m - l.height), l.height = m), t) {
    const R = l.width / l.height;
    if (R < t) {
      const S = Math.max(l.width / t, f);
      (e === "nw" || e == "ne") && (l.y -= S - l.height), l.height = S;
    } else if (R > t) {
      const S = Math.max(l.height * t, d);
      (e === "sw" || e == "nw") && (l.x -= S - l.width), l.width = S;
    }
  }
  return l;
}
function Xs(r, t, e, n) {
  const o = xe({}, r);
  return t === "ArrowLeft" ? n === "nw" ? (o.x -= e, o.y -= e, o.width += e, o.height += e) : n === "w" ? (o.x -= e, o.width += e) : n === "sw" ? (o.x -= e, o.width += e, o.height += e) : n === "ne" ? (o.y += e, o.width -= e, o.height -= e) : n === "e" ? o.width -= e : n === "se" && (o.width -= e, o.height -= e) : t === "ArrowRight" && (n === "nw" ? (o.x += e, o.y += e, o.width -= e, o.height -= e) : n === "w" ? (o.x += e, o.width -= e) : n === "sw" ? (o.x += e, o.width -= e, o.height -= e) : n === "ne" ? (o.y -= e, o.width += e, o.height += e) : n === "e" ? o.width += e : n === "se" && (o.width += e, o.height += e)), t === "ArrowUp" ? n === "nw" ? (o.x -= e, o.y -= e, o.width += e, o.height += e) : n === "n" ? (o.y -= e, o.height += e) : n === "ne" ? (o.y -= e, o.width += e, o.height += e) : n === "sw" ? (o.x += e, o.width -= e, o.height -= e) : n === "s" ? o.height -= e : n === "se" && (o.width -= e, o.height -= e) : t === "ArrowDown" && (n === "nw" ? (o.x += e, o.y += e, o.width -= e, o.height -= e) : n === "n" ? (o.y += e, o.height -= e) : n === "ne" ? (o.y += e, o.width -= e, o.height -= e) : n === "sw" ? (o.x -= e, o.width += e, o.height += e) : n === "s" ? o.height += e : n === "se" && (o.width += e, o.height += e)), o;
}
const We = { capture: !0, passive: !1 };
let Js = 0;
const Pe = class Se extends ro {
  constructor() {
    super(...arguments), Q(this, "docMoveBound", !1), Q(this, "mouseDownOnCrop", !1), Q(this, "dragStarted", !1), Q(this, "evData", {
      startClientX: 0,
      startClientY: 0,
      startCropX: 0,
      startCropY: 0,
      clientX: 0,
      clientY: 0,
      isResize: !0
    }), Q(this, "componentRef", Ht()), Q(this, "mediaRef", Ht()), Q(this, "resizeObserver"), Q(this, "initChangeCalled", !1), Q(this, "instanceId", `rc-${Js++}`), Q(this, "state", {
      cropIsActive: !1,
      newCropIsBeingDrawn: !1
    }), Q(this, "onCropPointerDown", (t) => {
      const { crop: e, disabled: n } = this.props, o = this.getBox();
      if (!e)
        return;
      const a = Ie(e, o.width, o.height);
      if (n)
        return;
      t.cancelable && t.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({ preventScroll: !0 });
      const s = t.target.dataset.ord, u = !!s;
      let c = t.clientX, l = t.clientY, d = a.x, f = a.y;
      if (s) {
        const y = t.clientX - o.x, m = t.clientY - o.y;
        let x = 0, C = 0;
        s === "ne" || s == "e" ? (x = y - (a.x + a.width), C = m - a.y, d = a.x, f = a.y + a.height) : s === "se" || s === "s" ? (x = y - (a.x + a.width), C = m - (a.y + a.height), d = a.x, f = a.y) : s === "sw" || s == "w" ? (x = y - a.x, C = m - (a.y + a.height), d = a.x + a.width, f = a.y) : (s === "nw" || s == "n") && (x = y - a.x, C = m - a.y, d = a.x + a.width, f = a.y + a.height), c = d + o.x + x, l = f + o.y + C;
      }
      this.evData = {
        startClientX: c,
        startClientY: l,
        startCropX: d,
        startCropY: f,
        clientX: t.clientX,
        clientY: t.clientY,
        isResize: u,
        ord: s
      }, this.mouseDownOnCrop = !0, this.setState({ cropIsActive: !0 });
    }), Q(this, "onComponentPointerDown", (t) => {
      const { crop: e, disabled: n, locked: o, keepSelection: a, onChange: s } = this.props, u = this.getBox();
      if (n || o || a && e)
        return;
      t.cancelable && t.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({ preventScroll: !0 });
      const c = t.clientX - u.x, l = t.clientY - u.y, d = {
        unit: "px",
        x: c,
        y: l,
        width: 0,
        height: 0
      };
      this.evData = {
        startClientX: t.clientX,
        startClientY: t.clientY,
        startCropX: c,
        startCropY: l,
        clientX: t.clientX,
        clientY: t.clientY,
        isResize: !0
      }, this.mouseDownOnCrop = !0, s(Ie(d, u.width, u.height), He(d, u.width, u.height)), this.setState({ cropIsActive: !0, newCropIsBeingDrawn: !0 });
    }), Q(this, "onDocPointerMove", (t) => {
      const { crop: e, disabled: n, onChange: o, onDragStart: a } = this.props, s = this.getBox();
      if (n || !e || !this.mouseDownOnCrop)
        return;
      t.cancelable && t.preventDefault(), this.dragStarted || (this.dragStarted = !0, a && a(t));
      const { evData: u } = this;
      u.clientX = t.clientX, u.clientY = t.clientY;
      let c;
      u.isResize ? c = this.resizeCrop() : c = this.dragCrop(), Vn(e, c) || o(
        Ie(c, s.width, s.height),
        He(c, s.width, s.height)
      );
    }), Q(this, "onComponentKeyDown", (t) => {
      const { crop: e, disabled: n, onChange: o, onComplete: a } = this.props;
      if (n)
        return;
      const s = t.key;
      let u = !1;
      if (!e)
        return;
      const c = this.getBox(), l = this.makePixelCrop(c), d = (navigator.platform.match("Mac") ? t.metaKey : t.ctrlKey) ? Se.nudgeStepLarge : t.shiftKey ? Se.nudgeStepMedium : Se.nudgeStep;
      if (s === "ArrowLeft" ? (l.x -= d, u = !0) : s === "ArrowRight" ? (l.x += d, u = !0) : s === "ArrowUp" ? (l.y -= d, u = !0) : s === "ArrowDown" && (l.y += d, u = !0), u) {
        t.cancelable && t.preventDefault(), l.x = Fe(l.x, 0, c.width - l.width), l.y = Fe(l.y, 0, c.height - l.height);
        const f = Ie(l, c.width, c.height), y = He(l, c.width, c.height);
        o(f, y), a && a(f, y);
      }
    }), Q(this, "onHandlerKeyDown", (t, e) => {
      const {
        aspect: n = 0,
        crop: o,
        disabled: a,
        minWidth: s = 0,
        minHeight: u = 0,
        maxWidth: c,
        maxHeight: l,
        onChange: d,
        onComplete: f
      } = this.props, y = this.getBox();
      if (a || !o)
        return;
      if (t.key === "ArrowUp" || t.key === "ArrowDown" || t.key === "ArrowLeft" || t.key === "ArrowRight")
        t.stopPropagation(), t.preventDefault();
      else
        return;
      const m = (navigator.platform.match("Mac") ? t.metaKey : t.ctrlKey) ? Se.nudgeStepLarge : t.shiftKey ? Se.nudgeStepMedium : Se.nudgeStep, x = Ie(o, y.width, y.height), C = Xs(x, t.key, m, e), R = Kn(
        C,
        n,
        e,
        y.width,
        y.height,
        s,
        u,
        c,
        l
      );
      if (!Vn(o, R)) {
        const S = He(R, y.width, y.height);
        d(R, S), f && f(R, S);
      }
    }), Q(this, "onDocPointerDone", (t) => {
      const { crop: e, disabled: n, onComplete: o, onDragEnd: a } = this.props, s = this.getBox();
      this.unbindDocMove(), !(n || !e) && this.mouseDownOnCrop && (this.mouseDownOnCrop = !1, this.dragStarted = !1, a && a(t), o && o(Ie(e, s.width, s.height), He(e, s.width, s.height)), this.setState({ cropIsActive: !1, newCropIsBeingDrawn: !1 }));
    }), Q(this, "onDragFocus", () => {
      var t;
      (t = this.componentRef.current) == null || t.scrollTo(0, 0);
    });
  }
  get document() {
    return document;
  }
  // We unfortunately get the bounding box every time as x+y changes
  // due to scrolling.
  getBox() {
    const t = this.mediaRef.current;
    if (!t)
      return { x: 0, y: 0, width: 0, height: 0 };
    const { x: e, y: n, width: o, height: a } = t.getBoundingClientRect();
    return { x: e, y: n, width: o, height: a };
  }
  componentDidUpdate(t) {
    const { crop: e, onComplete: n } = this.props;
    if (n && !t.crop && e) {
      const { width: o, height: a } = this.getBox();
      o && a && n(Ie(e, o, a), He(e, o, a));
    }
  }
  componentWillUnmount() {
    this.resizeObserver && this.resizeObserver.disconnect(), this.unbindDocMove();
  }
  bindDocMove() {
    this.docMoveBound || (this.document.addEventListener("pointermove", this.onDocPointerMove, We), this.document.addEventListener("pointerup", this.onDocPointerDone, We), this.document.addEventListener("pointercancel", this.onDocPointerDone, We), this.docMoveBound = !0);
  }
  unbindDocMove() {
    this.docMoveBound && (this.document.removeEventListener("pointermove", this.onDocPointerMove, We), this.document.removeEventListener("pointerup", this.onDocPointerDone, We), this.document.removeEventListener("pointercancel", this.onDocPointerDone, We), this.docMoveBound = !1);
  }
  getCropStyle() {
    const { crop: t } = this.props;
    if (t)
      return {
        top: `${t.y}${t.unit}`,
        left: `${t.x}${t.unit}`,
        width: `${t.width}${t.unit}`,
        height: `${t.height}${t.unit}`
      };
  }
  dragCrop() {
    const { evData: t } = this, e = this.getBox(), n = this.makePixelCrop(e), o = t.clientX - t.startClientX, a = t.clientY - t.startClientY;
    return n.x = Fe(t.startCropX + o, 0, e.width - n.width), n.y = Fe(t.startCropY + a, 0, e.height - n.height), n;
  }
  getPointRegion(t, e, n, o) {
    const { evData: a } = this, s = a.clientX - t.x, u = a.clientY - t.y;
    let c;
    o && e ? c = e === "nw" || e === "n" || e === "ne" : c = u < a.startCropY;
    let l;
    return n && e ? l = e === "nw" || e === "w" || e === "sw" : l = s < a.startCropX, l ? c ? "nw" : "sw" : c ? "ne" : "se";
  }
  resolveMinDimensions(t, e, n = 0, o = 0) {
    const a = Math.min(n, t.width), s = Math.min(o, t.height);
    return !e || !a && !s ? [a, s] : e > 1 ? a ? [a, a / e] : [s * e, s] : s ? [s * e, s] : [a, a / e];
  }
  resizeCrop() {
    const { evData: t } = this, { aspect: e = 0, maxWidth: n, maxHeight: o } = this.props, a = this.getBox(), [s, u] = this.resolveMinDimensions(a, e, this.props.minWidth, this.props.minHeight);
    let c = this.makePixelCrop(a);
    const l = this.getPointRegion(a, t.ord, s, u), d = t.ord || l;
    let f = t.clientX - t.startClientX, y = t.clientY - t.startClientY;
    (s && d === "nw" || d === "w" || d === "sw") && (f = Math.min(f, -s)), (u && d === "nw" || d === "n" || d === "ne") && (y = Math.min(y, -u));
    const m = {
      unit: "px",
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
    l === "ne" ? (m.x = t.startCropX, m.width = f, e ? (m.height = m.width / e, m.y = t.startCropY - m.height) : (m.height = Math.abs(y), m.y = t.startCropY - m.height)) : l === "se" ? (m.x = t.startCropX, m.y = t.startCropY, m.width = f, e ? m.height = m.width / e : m.height = y) : l === "sw" ? (m.x = t.startCropX + f, m.y = t.startCropY, m.width = Math.abs(f), e ? m.height = m.width / e : m.height = y) : l === "nw" && (m.x = t.startCropX + f, m.width = Math.abs(f), e ? (m.height = m.width / e, m.y = t.startCropY - m.height) : (m.height = Math.abs(y), m.y = t.startCropY + y));
    const x = Kn(
      m,
      e,
      l,
      a.width,
      a.height,
      s,
      u,
      n,
      o
    );
    return e || Se.xyOrds.indexOf(d) > -1 ? c = x : Se.xOrds.indexOf(d) > -1 ? (c.x = x.x, c.width = x.width) : Se.yOrds.indexOf(d) > -1 && (c.y = x.y, c.height = x.height), c.x = Fe(c.x, 0, a.width - c.width), c.y = Fe(c.y, 0, a.height - c.height), c;
  }
  renderCropSelection() {
    const {
      ariaLabels: t = Se.defaultProps.ariaLabels,
      disabled: e,
      locked: n,
      renderSelectionAddon: o,
      ruleOfThirds: a,
      crop: s
    } = this.props, u = this.getCropStyle();
    if (s)
      return /* @__PURE__ */ W.createElement(
        "div",
        {
          style: u,
          className: "ReactCrop__crop-selection",
          onPointerDown: this.onCropPointerDown,
          "aria-label": t.cropArea,
          tabIndex: 0,
          onKeyDown: this.onComponentKeyDown,
          role: "group"
        },
        !e && !n && /* @__PURE__ */ W.createElement("div", { className: "ReactCrop__drag-elements", onFocus: this.onDragFocus }, /* @__PURE__ */ W.createElement("div", { className: "ReactCrop__drag-bar ord-n", "data-ord": "n" }), /* @__PURE__ */ W.createElement("div", { className: "ReactCrop__drag-bar ord-e", "data-ord": "e" }), /* @__PURE__ */ W.createElement("div", { className: "ReactCrop__drag-bar ord-s", "data-ord": "s" }), /* @__PURE__ */ W.createElement("div", { className: "ReactCrop__drag-bar ord-w", "data-ord": "w" }), /* @__PURE__ */ W.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-nw",
            "data-ord": "nw",
            tabIndex: 0,
            "aria-label": t.nwDragHandle,
            onKeyDown: (c) => this.onHandlerKeyDown(c, "nw"),
            role: "button"
          }
        ), /* @__PURE__ */ W.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-n",
            "data-ord": "n",
            tabIndex: 0,
            "aria-label": t.nDragHandle,
            onKeyDown: (c) => this.onHandlerKeyDown(c, "n"),
            role: "button"
          }
        ), /* @__PURE__ */ W.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-ne",
            "data-ord": "ne",
            tabIndex: 0,
            "aria-label": t.neDragHandle,
            onKeyDown: (c) => this.onHandlerKeyDown(c, "ne"),
            role: "button"
          }
        ), /* @__PURE__ */ W.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-e",
            "data-ord": "e",
            tabIndex: 0,
            "aria-label": t.eDragHandle,
            onKeyDown: (c) => this.onHandlerKeyDown(c, "e"),
            role: "button"
          }
        ), /* @__PURE__ */ W.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-se",
            "data-ord": "se",
            tabIndex: 0,
            "aria-label": t.seDragHandle,
            onKeyDown: (c) => this.onHandlerKeyDown(c, "se"),
            role: "button"
          }
        ), /* @__PURE__ */ W.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-s",
            "data-ord": "s",
            tabIndex: 0,
            "aria-label": t.sDragHandle,
            onKeyDown: (c) => this.onHandlerKeyDown(c, "s"),
            role: "button"
          }
        ), /* @__PURE__ */ W.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-sw",
            "data-ord": "sw",
            tabIndex: 0,
            "aria-label": t.swDragHandle,
            onKeyDown: (c) => this.onHandlerKeyDown(c, "sw"),
            role: "button"
          }
        ), /* @__PURE__ */ W.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-w",
            "data-ord": "w",
            tabIndex: 0,
            "aria-label": t.wDragHandle,
            onKeyDown: (c) => this.onHandlerKeyDown(c, "w"),
            role: "button"
          }
        )),
        o && /* @__PURE__ */ W.createElement("div", { className: "ReactCrop__selection-addon", onPointerDown: (c) => c.stopPropagation() }, o(this.state)),
        a && /* @__PURE__ */ W.createElement(W.Fragment, null, /* @__PURE__ */ W.createElement("div", { className: "ReactCrop__rule-of-thirds-hz" }), /* @__PURE__ */ W.createElement("div", { className: "ReactCrop__rule-of-thirds-vt" }))
      );
  }
  makePixelCrop(t) {
    const e = xe(xe({}, sr), this.props.crop || {});
    return Ie(e, t.width, t.height);
  }
  render() {
    const { aspect: t, children: e, circularCrop: n, className: o, crop: a, disabled: s, locked: u, style: c, ruleOfThirds: l } = this.props, { cropIsActive: d, newCropIsBeingDrawn: f } = this.state, y = a ? this.renderCropSelection() : null, m = Qs(
      "ReactCrop",
      o,
      d && "ReactCrop--active",
      s && "ReactCrop--disabled",
      u && "ReactCrop--locked",
      f && "ReactCrop--new-crop",
      a && t && "ReactCrop--fixed-aspect",
      a && n && "ReactCrop--circular-crop",
      a && l && "ReactCrop--rule-of-thirds",
      !this.dragStarted && a && !a.width && !a.height && "ReactCrop--invisible-crop",
      n && "ReactCrop--no-animate"
    );
    return /* @__PURE__ */ W.createElement("div", { ref: this.componentRef, className: m, style: c }, /* @__PURE__ */ W.createElement("div", { ref: this.mediaRef, className: "ReactCrop__child-wrapper", onPointerDown: this.onComponentPointerDown }, e), a ? /* @__PURE__ */ W.createElement("svg", { className: "ReactCrop__crop-mask", width: "100%", height: "100%" }, /* @__PURE__ */ W.createElement("defs", null, /* @__PURE__ */ W.createElement("mask", { id: `hole-${this.instanceId}` }, /* @__PURE__ */ W.createElement("rect", { width: "100%", height: "100%", fill: "white" }), n ? /* @__PURE__ */ W.createElement(
      "ellipse",
      {
        cx: `${a.x + a.width / 2}${a.unit}`,
        cy: `${a.y + a.height / 2}${a.unit}`,
        rx: `${a.width / 2}${a.unit}`,
        ry: `${a.height / 2}${a.unit}`,
        fill: "black"
      }
    ) : /* @__PURE__ */ W.createElement(
      "rect",
      {
        x: `${a.x}${a.unit}`,
        y: `${a.y}${a.unit}`,
        width: `${a.width}${a.unit}`,
        height: `${a.height}${a.unit}`,
        fill: "black"
      }
    ))), /* @__PURE__ */ W.createElement("rect", { fill: "black", fillOpacity: 0.5, width: "100%", height: "100%", mask: `url(#hole-${this.instanceId})` })) : void 0, y);
  }
};
Q(Pe, "xOrds", ["e", "w"]), Q(Pe, "yOrds", ["n", "s"]), Q(Pe, "xyOrds", ["nw", "ne", "se", "sw"]), Q(Pe, "nudgeStep", 1), Q(Pe, "nudgeStepMedium", 10), Q(Pe, "nudgeStepLarge", 100), Q(Pe, "defaultProps", {
  ariaLabels: {
    cropArea: "Use the arrow keys to move the crop selection area",
    nwDragHandle: "Use the arrow keys to move the north west drag handle to change the crop selection area",
    nDragHandle: "Use the up and down arrow keys to move the north drag handle to change the crop selection area",
    neDragHandle: "Use the arrow keys to move the north east drag handle to change the crop selection area",
    eDragHandle: "Use the up and down arrow keys to move the east drag handle to change the crop selection area",
    seDragHandle: "Use the arrow keys to move the south east drag handle to change the crop selection area",
    sDragHandle: "Use the up and down arrow keys to move the south drag handle to change the crop selection area",
    swDragHandle: "Use the arrow keys to move the south west drag handle to change the crop selection area",
    wDragHandle: "Use the up and down arrow keys to move the west drag handle to change the crop selection area"
  }
});
let Zs = Pe;
const ec = "ImageReview-module__imageReviewContent__donhT", rc = "ImageReview-module__reviewHeader__ghg5T", tc = "ImageReview-module__backButton__1rdyM", nc = "ImageReview-module__imageContainer__HyLd2", ac = "ImageReview-module__cropContainer__2jDeq", oc = "ImageReview-module__documentImage__b74Q4", ic = "ImageReview-module__actionButtons__rdJYG", sc = "ImageReview-module__customButton__4sXmo", cc = "ImageReview-module__secondaryButton__K6TQq", Re = {
  imageReviewContent: ec,
  reviewHeader: rc,
  backButton: tc,
  imageContainer: nc,
  cropContainer: ac,
  documentImage: oc,
  actionButtons: ic,
  customButton: sc,
  secondaryButton: cc
}, ct = 1920, ut = 1080, uc = 0.7;
var lc = (r, t, e) => new Promise((n, o) => {
  var a = (c) => {
    try {
      u(e.next(c));
    } catch (l) {
      o(l);
    }
  }, s = (c) => {
    try {
      u(e.throw(c));
    } catch (l) {
      o(l);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(a, s);
  u((e = e.apply(r, t)).next());
});
const dc = ({ image: r, onAccept: t, onRetry: e, onBack: n, lastSource: o }) => {
  const { translations: a } = Ge(Qe), [s, u] = ue(0), [c, l] = ue({
    unit: "%",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }), [d, f] = ue(null), y = lt(null), m = () => lc(null, null, function* () {
    if (!y.current) return;
    const x = y.current;
    try {
      const C = document.createElement("canvas"), R = C.getContext("2d"), S = x.naturalWidth / x.width, k = x.naturalHeight / x.height, D = d ? Math.round(d.width * S) : x.naturalWidth, T = d ? Math.round(d.height * k) : x.naturalHeight;
      let g = D, J = T;
      D > T ? D > ct && (J = Math.round(T * ct / D), g = ct) : T > ut && (g = Math.round(D * ut / T), J = ut), C.width = g, C.height = J, s && (R.save(), R.translate(C.width / 2, C.height / 2), R.rotate(s * Math.PI / 180), R.translate(-C.width / 2, -C.height / 2)), d ? R.drawImage(
        x,
        d.x * S,
        d.y * k,
        D,
        T,
        0,
        0,
        g,
        J
      ) : R.drawImage(
        x,
        0,
        0,
        x.naturalWidth,
        x.naturalHeight,
        0,
        0,
        g,
        J
      ), s && R.restore();
      const ce = C.toDataURL("image/jpeg", uc), ne = (ce.length - 23) * 0.75 / (1024 * 1024);
      console.log(`Tamaño final de la imagen: ${ne.toFixed(2)}MB`), t(ce);
    } catch (C) {
      console.error("Error al procesar la imagen:", C);
    }
  });
  return /* @__PURE__ */ v.jsx("div", { className: Re.imageReviewContainer, children: /* @__PURE__ */ v.jsxs("div", { className: Re.imageReviewContent, children: [
    /* @__PURE__ */ v.jsxs("div", { className: Re.reviewHeader, children: [
      /* @__PURE__ */ v.jsx(
        Ee,
        {
          icon: /* @__PURE__ */ v.jsx(Ct, {}),
          onClick: n,
          className: Re.backButton,
          type: "text"
        }
      ),
      /* @__PURE__ */ v.jsx("h2", { children: a.onboarding_doc_capturer_title_review })
    ] }),
    /* @__PURE__ */ v.jsx("p", { children: a.onboarding_doc_capturer_subtitle_review }),
    /* @__PURE__ */ v.jsx("div", { className: Re.imageContainer, children: /* @__PURE__ */ v.jsx("div", { className: Re.cropContainer, children: /* @__PURE__ */ v.jsx(
      Zs,
      {
        crop: c,
        onChange: (x) => l(x),
        onComplete: (x) => f(x),
        minWidth: 10,
        minHeight: 10,
        keepSelection: !0,
        style: { margin: "10px" },
        children: /* @__PURE__ */ v.jsx(
          "img",
          {
            ref: y,
            src: r,
            alt: "Documento",
            style: {
              transform: `rotate(${s}deg)`,
              maxWidth: "100%",
              maxHeight: "70vh"
            },
            className: Re.documentImage
          }
        )
      }
    ) }) }),
    /* @__PURE__ */ v.jsxs("div", { className: Re.actionButtons, children: [
      /* @__PURE__ */ v.jsx(
        Ee,
        {
          onClick: () => e(o),
          className: `${Re.secondaryButton} ${Re.customButton}`,
          icon: /* @__PURE__ */ v.jsx(xa, {}),
          style: { width: "200px" },
          children: a.onboarding_doc_capturer_review_back
        }
      ),
      /* @__PURE__ */ v.jsx(
        Ee,
        {
          onClick: m,
          icon: /* @__PURE__ */ v.jsx(ya, {}),
          className: Re.customButton,
          style: { width: "200px" },
          children: a.onboarding_doc_capturer_review_ok
        }
      )
    ] })
  ] }) });
}, fc = "CameraCapture-module__cameraCapture__08hAx", pc = "CameraCapture-module__cameraContainer__fU6-u", hc = "CameraCapture-module__cameraVideo__lU2zs", mc = "CameraCapture-module__cameraOverlay__Met-g", vc = "CameraCapture-module__cameraOverlayContent__qBDAw", gc = "CameraCapture-module__cameraOverlayContentFront__NXYAa", yc = "CameraCapture-module__cameraOverlayContentBack__NOguo", bc = "CameraCapture-module__instructionText__89y5g", _c = "CameraCapture-module__poweredBy__iRBrW", wc = "CameraCapture-module__captureButtonContainer__adMMT", Cc = "CameraCapture-module__captureButton__bOA-3", xc = "CameraCapture-module__instructionHeader__K6-4W", Rc = "CameraCapture-module__infoButton__HRrBm", Oc = "CameraCapture-module__captureInstructions__LRqYU", Sc = "CameraCapture-module__instructionsTitle__WC9-d", Ec = "CameraCapture-module__instructionIcon__c5Tee", Tc = "CameraCapture-module__captureInstructionsTooltip__fblCw", oe = {
  cameraCapture: fc,
  cameraContainer: pc,
  cameraVideo: hc,
  cameraOverlay: mc,
  cameraOverlayContent: vc,
  cameraOverlayContentFront: gc,
  cameraOverlayContentBack: yc,
  instructionText: bc,
  poweredBy: _c,
  captureButtonContainer: wc,
  captureButton: Cc,
  instructionHeader: xc,
  infoButton: Rc,
  captureInstructions: Oc,
  instructionsTitle: Sc,
  instructionIcon: Ec,
  captureInstructionsTooltip: Tc
}, Ic = "data:image/png;base64,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", Pc = ({
  onCapture: r,
  onBack: t,
  cameraStream: e,
  facingModePreset: n,
  isBackSide: o
}) => {
  const { translations: a } = Ge(Qe), s = lt(null), [u, c] = ue(!1), [l, d] = ue(n), f = lt(null), y = o ? oe.cameraOverlayContentBack : oe.cameraOverlayContentFront;
  $e(() => {
    e && s.current && (s.current.srcObject = e, c(!0));
  }, [e]);
  const m = () => {
    s.current && (s.current.srcObject = null, c(!1));
  }, x = () => {
    if (!s.current || !u || !f.current) return;
    const R = f.current.getBoundingClientRect(), S = s.current.getBoundingClientRect(), k = s.current.videoWidth / S.width, D = s.current.videoHeight / S.height, T = (R.left - S.left) * k, g = (R.top - S.top) * D, J = R.width * k, ce = R.height * D, $ = document.createElement("canvas"), ne = $.getContext("2d");
    $.width = J, $.height = ce, ne.drawImage(
      s.current,
      T,
      g,
      J,
      ce,
      0,
      0,
      $.width,
      $.height
    ), l === "user" && (ne.translate($.width, 0), ne.scale(-1, 1), ne.drawImage($, -$.width, 0));
    const ie = $.toDataURL("image/jpeg");
    r(ie), m();
  };
  $e(() => () => m(), []);
  const C = /* @__PURE__ */ v.jsxs("div", { className: oe.captureInstructions, children: [
    /* @__PURE__ */ v.jsx("h1", { className: oe.instructionsTitle, children: a.onboarding_doc_capturer_capture_instructions_title }),
    /* @__PURE__ */ v.jsxs("ul", { children: [
      /* @__PURE__ */ v.jsxs("li", { children: [
        /* @__PURE__ */ v.jsx("span", { className: oe.instructionIcon, children: /* @__PURE__ */ v.jsx(ga, {}) }),
        /* @__PURE__ */ v.jsx("span", { className: oe.instructionText, children: a.onboarding_doc_capturer_capture_instruction_1 })
      ] }),
      /* @__PURE__ */ v.jsxs("li", { children: [
        /* @__PURE__ */ v.jsx("span", { className: oe.instructionIcon, children: /* @__PURE__ */ v.jsx(va, {}) }),
        /* @__PURE__ */ v.jsx("span", { className: oe.instructionText, children: a.onboarding_doc_capturer_capture_instruction_2 })
      ] })
    ] })
  ] });
  return /* @__PURE__ */ v.jsx("div", { className: oe.cameraCapture, children: /* @__PURE__ */ v.jsxs("div", { className: oe.cameraContainer, children: [
    /* @__PURE__ */ v.jsx(
      "video",
      {
        ref: s,
        className: oe.cameraVideo,
        autoPlay: !0,
        playsInline: !0,
        muted: !0,
        style: { transform: l === "user" ? "scaleX(-1)" : "none" }
      }
    ),
    /* @__PURE__ */ v.jsxs("div", { className: oe.cameraOverlay, children: [
      /* @__PURE__ */ v.jsx("div", { className: oe.instructionHeader, children: /* @__PURE__ */ v.jsxs("div", { className: oe.instructionText, style: { color: "#fff" }, children: [
        a.onboarding_doc_capturer_check_position,
        /* @__PURE__ */ v.jsx(
          to,
          {
            title: C,
            placement: "right",
            color: "#fff",
            trigger: "click",
            overlayClassName: oe.captureInstructionsTooltip,
            mouseEnterDelay: 0,
            mouseLeaveDelay: 0.1,
            children: /* @__PURE__ */ v.jsx(
              Ee,
              {
                type: "text",
                icon: /* @__PURE__ */ v.jsx(_a, {}),
                className: oe.infoButton,
                onClick: (R) => {
                  R.preventDefault(), R.stopPropagation();
                },
                style: { zIndex: 1e3 }
              }
            )
          }
        )
      ] }) }),
      /* @__PURE__ */ v.jsx(
        "div",
        {
          className: `${oe.cameraOverlayContent} ${y}`,
          style: { transform: l === "user" ? "scaleX(-1)" : "none" },
          ref: f
        }
      ),
      /* @__PURE__ */ v.jsxs("div", { className: oe.poweredBy, children: [
        /* @__PURE__ */ v.jsx("span", { children: "Powered by" }),
        /* @__PURE__ */ v.jsx(
          "img",
          {
            src: Ic,
            alt: "Civitfun Logo"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ v.jsx("div", { className: oe.captureButtonContainer, children: /* @__PURE__ */ v.jsx(
      Ee,
      {
        type: "primary",
        shape: "circle",
        icon: /* @__PURE__ */ v.jsx(ir, {}),
        size: "large",
        onClick: x,
        className: oe.captureButton,
        disabled: !u
      }
    ) })
  ] }) });
}, cr = {
  FRONT: "front",
  BACK: "back"
}, Ra = {
  IDCARD: "IDCARD",
  PASSPORT: "PASSPORT",
  RESIDENCEPERMIT: "RESIDENCEPERMIT",
  DRIVERLICENSE: "DRIVERLICENSE",
  HEALTHINSURANCECARD: "HEALTHINSURANCECARD"
}, je = {
  ALL: "all",
  FILE: "file",
  CAMERA: "camera"
}, xt = {
  theme: le.string,
  iconTheme: le.string,
  iconVariant: le.string,
  style: le.shape({
    color_primary: le.string,
    color_secondary: le.string,
    color_check: le.string,
    color_background: le.string,
    button_font_color: le.string
  })
}, Oa = {
  allowedSources: le.oneOf(Object.values(je)),
  cameraType: le.oneOf(Object.values(cr)),
  country: le.string,
  documentType: le.oneOf(Object.values(Ra)),
  onComplete: le.func.isRequired,
  language: le.string,
  themeConfig: le.shape(xt)
}, ru = {
  CAMERA_TYPES: cr,
  DOCUMENT_TYPES: Ra,
  ALLOWED_SOURCES: je,
  ThemeConfigPropTypes: xt,
  OcrScannerPropTypes: Oa
};
var jc = Object.defineProperty, Ac = Object.defineProperties, Dc = Object.getOwnPropertyDescriptors, $n = Object.getOwnPropertySymbols, Mc = Object.prototype.hasOwnProperty, kc = Object.prototype.propertyIsEnumerable, Gn = (r, t, e) => t in r ? jc(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, Nc = (r, t) => {
  for (var e in t || (t = {}))
    Mc.call(t, e) && Gn(r, e, t[e]);
  if ($n)
    for (var e of $n(t))
      kc.call(t, e) && Gn(r, e, t[e]);
  return r;
}, Lc = (r, t) => Ac(r, Dc(t)), Bc = (r, t, e) => new Promise((n, o) => {
  var a = (c) => {
    try {
      u(e.next(c));
    } catch (l) {
      o(l);
    }
  }, s = (c) => {
    try {
      u(e.throw(c));
    } catch (l) {
      o(l);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(a, s);
  u((e = e.apply(r, t)).next());
});
const Fc = ({ country: r, documentType: t, onComplete: e }) => {
  const { translations: n } = Ge(Qe), [o, a] = ue(0), [s, u] = ue({ front: null, back: null }), [c, l] = ue(!1), [d, f] = ue(null), [y, m] = ue(null), [x, C] = ue(null), [R, S] = ue(null), [k, D] = ue(!1), [T, g] = ue(null), ce = ((V, G) => ({
    PASSPORT: !1,
    IDCARD: !0,
    RESIDENCEPERMIT: !0,
    DRIVERLICENSE: !0,
    HEALTHINSURANCECARD: !1
  })[G])(r, t), $ = {
    IDCARD: n.onboarding_sides_title_id_card,
    PASSPORT: n.onboarding_sides_title_passport,
    RESIDENCEPERMIT: n.onboarding_sides_title_residence_permit,
    DRIVERLICENSE: n.onboarding_sides_title_driver_license,
    HEALTHINSURANCECARD: n.onboarding_sides_title_health_insurance_card
  }, ne = (V) => $[V] || "", ie = (V) => Bc(null, null, function* () {
    try {
      T && T.getTracks().forEach((p) => p.stop());
      const G = yield navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: V === "front" ? "user" : "environment",
          width: { ideal: 1280 },
          height: { ideal: 720 },
          torch: !1
        }
      });
      g(G), D(!0);
    } catch (G) {
      no.error("Error al acceder a la cámara: " + G.message), D(!1);
    }
  }), ve = () => {
    T && (T.getTracks().forEach((V) => V.stop()), g(null)), D(!1);
  }, ge = ({ file: V }) => {
    const G = new FileReader();
    G.onload = (p) => {
      m(p.target.result), C(d), re();
    }, G.readAsDataURL(V);
  }, se = (V) => {
    const G = x || (s.front === null ? "front" : "back");
    u((p) => {
      const b = Lc(Nc({}, p), {
        [G]: V
      });
      return ce ? b.front !== null && b.back !== null && e(b) : b.front !== null && e(b), b;
    }), m(null), C(null);
  }, ee = () => {
    m(null), C(null), de(d);
  }, de = (V, G, p) => {
    G === je.CAMERA ? (f(V), ie(p)) : (f(V), l(!0));
  }, re = () => {
    l(!1);
  }, fe = () => {
    m(null), C(null);
  };
  return {
    currentStep: o,
    setCurrentStep: a,
    images: s,
    isModalVisible: c,
    selectedSide: d,
    reviewImage: y,
    reviewSide: x,
    lastSource: R,
    isCameraActive: k,
    cameraStream: T,
    scanBothSides: ce,
    documentTypeTitles: $,
    documentTitle: $[t],
    getDocumentTypeText: ne,
    startCamera: ie,
    stopCamera: ve,
    handleFileUpload: ge,
    handleImageAccept: se,
    handleImageRetry: ee,
    showUploadModal: de,
    handleModalCancel: re,
    handleBack: fe,
    setLastSource: S,
    setReviewImage: m,
    setReviewSide: C
  };
};
var Hc = Object.defineProperty, Wc = Object.defineProperties, Uc = Object.getOwnPropertyDescriptors, Qn = Object.getOwnPropertySymbols, qc = Object.prototype.hasOwnProperty, zc = Object.prototype.propertyIsEnumerable, Xn = (r, t, e) => t in r ? Hc(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, Yc = (r, t) => {
  for (var e in t || (t = {}))
    qc.call(t, e) && Xn(r, e, t[e]);
  if (Qn)
    for (var e of Qn(t))
      zc.call(t, e) && Xn(r, e, t[e]);
  return r;
}, Vc = (r, t) => Wc(r, Uc(t)), Kc = (r, t, e) => new Promise((n, o) => {
  var a = (c) => {
    try {
      u(e.next(c));
    } catch (l) {
      o(l);
    }
  }, s = (c) => {
    try {
      u(e.throw(c));
    } catch (l) {
      o(l);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(a, s);
  u((e = e.apply(r, t)).next());
});
const Sa = ({
  allowedSources: r = je.ALL,
  cameraType: t = cr.BACK,
  country: e,
  documentType: n,
  onComplete: o,
  onCancel: a,
  onError: s,
  language: u = "es",
  themeConfig: c = {}
}) => {
  var l, d;
  const { translations: f, isLoading: y, setLanguage: m } = Ge(Qe), [x, C] = ue("");
  $e(() => {
    Ea(e, u).then((O) => C(O));
  }, [e, u]), m(u);
  const {
    currentStep: R,
    setCurrentStep: S,
    images: k,
    isModalVisible: D,
    selectedSide: T,
    reviewImage: g,
    lastSource: J,
    isCameraActive: ce,
    cameraStream: $,
    scanBothSides: ne,
    documentTitle: ie,
    getDocumentTypeText: ve,
    startCamera: ge,
    stopCamera: se,
    handleFileUpload: ee,
    handleImageAccept: de,
    handleImageRetry: re,
    showUploadModal: fe,
    handleModalCancel: V,
    handleBack: G,
    setLastSource: p,
    setReviewImage: b,
    setReviewSide: M
  } = Fc({ country: e, documentType: n, onComplete: o });
  c.style, (l = c.style) != null && l.color_primary;
  const [P, E] = W.useState(!1), L = () => {
    R === 0 ? E(!0) : (G(), S(R - 1));
  }, j = () => {
    E(!1);
  }, A = () => {
    E(!1);
  };
  if (y)
    return null;
  const N = (O) => /* @__PURE__ */ v.jsx(
    "div",
    {
      className: Z.documentPlaceholder,
      onClick: () => fe(O, r, t),
      role: "button",
      tabIndex: 0,
      children: k[O] ? /* @__PURE__ */ v.jsx(
        "img",
        {
          src: k[O],
          alt: `${O === "front" ? "Frontal" : "Trasera"}`,
          className: Z.uploadedImage,
          style: { width: "100%", height: "100%", objectFit: "cover" }
        }
      ) : /* @__PURE__ */ v.jsx("div", { className: `${Z.placeholderContent} ${Z[O]}` })
    }
  ), F = [
    {
      title: "Información",
      content: /* @__PURE__ */ v.jsxs("div", { className: Z.stepContent, children: [
        /* @__PURE__ */ v.jsx("h2", { children: f.onboarding_stages_title }),
        /* @__PURE__ */ v.jsx("p", { children: f.onboarding_stages_description }),
        /* @__PURE__ */ v.jsxs(
          "div",
          {
            className: Z.documentOption,
            onClick: () => S(R + 1),
            role: "button",
            tabIndex: 0,
            children: [
              /* @__PURE__ */ v.jsxs("div", { className: Z.documentOptionLeft, children: [
                /* @__PURE__ */ v.jsx("div", { className: Z.documentIcon, children: /* @__PURE__ */ v.jsx(ba, {}) }),
                /* @__PURE__ */ v.jsx("span", { children: ve(n) })
              ] }),
              /* @__PURE__ */ v.jsx("div", { className: Z.documentOptionRight, children: /* @__PURE__ */ v.jsx(Ca, {}) })
            ]
          }
        )
      ] })
    },
    {
      title: "Captura",
      content: /* @__PURE__ */ v.jsxs("div", { className: Z.stepContent, children: [
        /* @__PURE__ */ v.jsx("h2", { className: Z.title, children: ie }),
        /* @__PURE__ */ v.jsx("p", { children: f.onboarding_sides_subtitle }),
        /* @__PURE__ */ v.jsx("div", { className: Z.countryLabel, children: x }),
        /* @__PURE__ */ v.jsxs("div", { className: Z.ocrDocumentSideItems, children: [
          /* @__PURE__ */ v.jsxs("div", { className: Z.ocrDocumentSideItem, children: [
            /* @__PURE__ */ v.jsx("span", { children: f.onboarding_doc_capturer_front }),
            N("front")
          ] }),
          ne && /* @__PURE__ */ v.jsxs("div", { className: Z.ocrDocumentSideItem, children: [
            /* @__PURE__ */ v.jsx("span", { children: f.onboarding_doc_capturer_back }),
            N("back")
          ] })
        ] }),
        /* @__PURE__ */ v.jsx(
          vr,
          {
            title: /* @__PURE__ */ v.jsx("h2", { className: Z.title, children: f.onboarding_doc_capturer_choose_source }),
            open: D,
            onCancel: V,
            footer: null,
            centered: !0,
            children: /* @__PURE__ */ v.jsxs("div", { className: Z.uploadOptions, children: [
              (r === je.ALL || r === je.CAMERA) && /* @__PURE__ */ v.jsx(
                Ee,
                {
                  icon: /* @__PURE__ */ v.jsx(ir, {}),
                  onClick: () => {
                    V(), ge(t);
                  },
                  className: Z.uploadButton,
                  children: f.onboarding_doc_capturer_source_camera
                }
              ),
              (r === je.ALL || r === je.FILE) && /* @__PURE__ */ v.jsx(
                ao,
                {
                  beforeUpload: () => !1,
                  onChange: (O) => {
                    ee(O), V();
                  },
                  showUploadList: !1,
                  children: /* @__PURE__ */ v.jsx(Ee, { icon: /* @__PURE__ */ v.jsx(wa, {}), className: Z.uploadButton, children: f.onboarding_doc_capturer_source_file })
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ v.jsx(
          vr,
          {
            title: /* @__PURE__ */ v.jsx("div", { style: { display: "flex", alignItems: "center", justifyContent: "center", paddingRight: "24px" }, children: /* @__PURE__ */ v.jsxs("span", { children: [
              /* @__PURE__ */ v.jsx(ir, { style: { marginRight: "8px" } }),
              `${ve(n)} - ${T === "back" ? f.onboarding_doc_capturer_back : f.onboarding_doc_capturer_front}`
            ] }) }),
            open: ce,
            onCancel: () => se(),
            footer: null,
            width: window.innerWidth <= 768 ? "100%" : "800px",
            style: {
              margin: 0,
              padding: 0,
              maxWidth: "100vw"
            },
            centered: window.innerWidth > 768,
            bodyStyle: {
              padding: window.innerWidth <= 768 ? "12px" : "20px",
              borderRadius: window.innerWidth <= 768 ? "0" : "12px",
              maxHeight: window.innerWidth <= 768 ? "100vh" : "90vh",
              overflow: "hidden"
            },
            children: /* @__PURE__ */ v.jsx(
              Pc,
              {
                cameraStream: $,
                facingModePreset: t === cr.FRONT ? "user" : "environment",
                onCapture: (O) => {
                  se(), b(O), M(T || (k.front === null ? "front" : "back")), p("camera");
                },
                documentType: n,
                isBackSide: T === "back"
              }
            )
          }
        )
      ] })
    }
  ];
  return g ? /* @__PURE__ */ v.jsx(
    dc,
    {
      image: g,
      onAccept: de,
      onRetry: re,
      onBack: G,
      lastSource: J
    }
  ) : /* @__PURE__ */ v.jsxs("div", { className: Z.ocrScanner, style: { backgroundColor: ((d = c == null ? void 0 : c.style) == null ? void 0 : d.color_background) || "#fff" }, children: [
    /* @__PURE__ */ v.jsxs("div", { className: Z.stepsContent, children: [
      /* @__PURE__ */ v.jsx(
        Ee,
        {
          type: "default",
          onClick: L,
          style: { border: "none", paddingLeft: "16px" },
          icon: /* @__PURE__ */ v.jsx(Ct, {}),
          className: Z.backButton
        }
      ),
      F[R].content
    ] }),
    /* @__PURE__ */ v.jsx(
      vr,
      {
        title: /* @__PURE__ */ v.jsx("h2", { className: Z.title, children: f.onboarding_alert_title_really_sure_to_exit }),
        open: P,
        onOk: j,
        onCancel: A,
        footer: [
          /* @__PURE__ */ v.jsx(Ee, { onClick: A, children: f.onboarding_ask_for_permissions_cancel_button }, "back"),
          /* @__PURE__ */ v.jsx(Ee, { onClick: a, children: f.onboarding_close }, "submit")
        ],
        centered: !0,
        width: (window.innerWidth <= 768, "50%"),
        style: {
          top: window.innerWidth <= 768 ? 0 : "5vh",
          margin: 0,
          padding: 0,
          maxWidth: "50%"
        },
        bodyStyle: {
          padding: window.innerWidth <= 768 ? "12px" : "20px",
          borderRadius: window.innerWidth <= 768 ? "0" : "12px",
          maxHeight: window.innerWidth <= 768 ? "100vh" : "90vh",
          overflow: "hidden"
        },
        children: /* @__PURE__ */ v.jsx("p", { style: { textAlign: "center" }, children: f.onboarding_alert_subtitle_really_sure_to_exit })
      }
    )
  ] });
}, Ea = (r, t) => Kc(null, null, function* () {
  try {
    const e = yield ra(/* @__PURE__ */ Object.assign({ "../../utils/nationalities.br.js": () => import("./nationalities.br-BFW7ZI4a.js"), "../../utils/nationalities.ca.js": () => import("./nationalities.ca-DydcoopD.js"), "../../utils/nationalities.de.js": () => import("./nationalities.de-B9jFiRgA.js"), "../../utils/nationalities.en.js": () => import("./nationalities.en-CpbiXsEu.js"), "../../utils/nationalities.es.js": () => import("./nationalities.es-RXZ2uLY6.js"), "../../utils/nationalities.fr.js": () => import("./nationalities.fr-CBnU_Q3L.js"), "../../utils/nationalities.it.js": () => import("./nationalities.it-BNPx4hjo.js") }), `../../utils/nationalities.${t}.js`, 4), { countriesIso3: n } = e, o = n.find((a) => a.value === r);
    return o ? o.label : r;
  } catch (e) {
    return t !== "en" ? Ea(r, "en") : r;
  }
});
Sa.propTypes = Vc(Yc({}, Oa), {
  language: le.string,
  themeConfig: le.shape(xt)
});
var $c = Object.defineProperty, Jn = Object.getOwnPropertySymbols, Gc = Object.prototype.hasOwnProperty, Qc = Object.prototype.propertyIsEnumerable, Zn = (r, t, e) => t in r ? $c(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, Xc = (r, t) => {
  for (var e in t || (t = {}))
    Gc.call(t, e) && Zn(r, e, t[e]);
  if (Jn)
    for (var e of Jn(t))
      Qc.call(t, e) && Zn(r, e, t[e]);
  return r;
};
const tu = (r) => /* @__PURE__ */ v.jsx(uo, { children: /* @__PURE__ */ v.jsx(Sa, Xc({}, r)) });
export {
  tu as OcrScanner,
  ru as OcrScannerPropTypes
};
